export const LocStrings: any = {
  "ne": {
    "SuccessHandlerError": "चुनौती पूरा भयो। आफ्नो खरिद पूरा गर्न चेकआउटमा फर्कनुहोस्।",
    "RdsConsentAccountDetailsLabel": "खाता विवरण",
    "RdsConsentLead": "तपाईं यस Microsoft खातामा PayPal खाता लिङ्क गर्दै हुनुहुन्छ।",
    "CancelHandlerError": "चुनौती रद्द गरियो। अर्को भुक्तानी विकल्प छनौट गर्न चेकआउटमा फर्कनुहोस्।",
    "DeviceFingerprintLoading": "लोड गर्दै",
    "AuthenticatePurchaseInstructions": "आफ्नो खरिद पूरा गर्न कृपया आफ्नो बैंकले प्रदान गरेका निर्देशनहरू पालना गर्नुहोस्। कृपया प्रतीक्षा गर्नुहोस्। यो पृष्ठ लोड हुन 5-10 सेकेन्ड लाग्न सक्छ।",
    "AuthenticatePurchaseHeader": "आफ्नो खरिद प्रमाणित गर्नुहोस्",
    "FailureHandlerError": "तपाईंको खरिदमा समस्या भयो। अर्को भुक्तानी विकल्प छनौट गर्न चेकआउटमा फर्कनुहोस्।",
    "CheckoutError": "केही गडबड भयो। चेकआउट पूरा भएन।",
    "RdsConsentCancel": "रद्द गर्नुहोस्",
    "RdsConsentMicrosoftAccountLabel": "Microsoft खाता",
    "RdsConsentConfirm": "पुष्टि गर्नुहोस्",
    "RdsConsentWarning": "यदि यो तपाईंको खाता होइन भने, रद्द गर्नुहोस् चयन गर्नुहोस्।",
    "RdsConsentTitle": "आफ्नो PayPal लिङ्क पुष्टि गर्नुहोस्",
    "RdsConsentRequestError": "हामीले तपाईंको छनौट प्रक्रिया गर्न सकेनौँ। फेरि प्रयास गर्नुहोस्।"
  },
  "id": {
    "SuccessHandlerError": "Tantangan selesai. Kembali ke check-out untuk menyelesaikan pembelian Anda.",
    "RdsConsentAccountDetailsLabel": "Detail akun",
    "RdsConsentLead": "Anda menautkan akun PayPal ke akun Microsoft ini.",
    "CancelHandlerError": "Tantangan dibatalkan. Kembali ke check-out untuk memilih opsi pembayaran lain.",
    "DeviceFingerprintLoading": "Memuat",
    "AuthenticatePurchaseInstructions": "Untuk menyelesaikan pembelian Anda, ikuti instruksi yang disediakan oleh bank Anda. Tunggu. Halaman ini dapat memakan waktu 5-10 detik untuk dimuat.",
    "AuthenticatePurchaseHeader": "Autentikasi pembelian Anda",
    "FailureHandlerError": "Terjadi masalah dengan pembelian Anda. Kembali ke check-out untuk memilih opsi pembayaran lain.",
    "CheckoutError": "Terjadi kesalahan. Checkout tidak selesai.",
    "RdsConsentCancel": "Batal",
    "RdsConsentMicrosoftAccountLabel": "Akun Microsoft",
    "RdsConsentConfirm": "Konfirmasikan",
    "RdsConsentWarning": "Jika ini bukan akun Anda, pilih Batal.",
    "RdsConsentTitle": "Konfirmasikan tautan PayPal Anda",
    "RdsConsentRequestError": "Kami tidak dapat memproses pilihan Anda. Coba lagi."
  },
  "tk": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "cs": {
    "SuccessHandlerError": "Výzva se dokončila. Vraťte se k pokladně a dokončete nákup.",
    "RdsConsentAccountDetailsLabel": "Podrobnosti o účtu",
    "RdsConsentLead": "Propojujete účet PayPal s tímto účtem Microsoft.",
    "CancelHandlerError": "Výzva byla zrušena. Vraťte se k pokladně a zvolte jinou možnost platby.",
    "DeviceFingerprintLoading": "Načítání",
    "AuthenticatePurchaseInstructions": "Chcete-li dokončit nákup, postupujte prosím podle pokynů vaší banky. Počkejte prosím. Načtení této stránky může trvat 5–10 sekund.",
    "AuthenticatePurchaseHeader": "Ověření nákupu",
    "FailureHandlerError": "Došlo k problému s vaším nákupem. Vraťte se k pokladně a zvolte jinou možnost platby.",
    "CheckoutError": "Něco se nepovedlo. Platba nebyla dokončena.",
    "RdsConsentCancel": "Zrušit",
    "RdsConsentMicrosoftAccountLabel": "Účet Microsoft",
    "RdsConsentConfirm": "Potvrdit",
    "RdsConsentWarning": "Pokud to není váš účet, vyberte Zrušit.",
    "RdsConsentTitle": "Potvrdit propojení s PayPalem",
    "RdsConsentRequestError": "Vaši volbu se nám nepodařilo zpracovat. Zkuste to znovu."
  },
  "sk": {
    "SuccessHandlerError": "Výzva bola dokončená. Vráťte sa do pokladne a dokončite nákup.",
    "RdsConsentAccountDetailsLabel": "Podrobnosti o konte",
    "RdsConsentLead": "Prepájate konto PayPal s týmto kontom Microsoft.",
    "CancelHandlerError": "Výzva bola zrušená. Vráťte sa do pokladne a vyberte inú možnosť platby.",
    "DeviceFingerprintLoading": "Načítava sa",
    "AuthenticatePurchaseInstructions": "Na dokončenie nákupu postupujte podľa pokynov vašej banky. Počkajte, prosím. Načítanie tejto stránky môže trvať 5 až 10 sekúnd.",
    "AuthenticatePurchaseHeader": "Overte svoj nákup",
    "FailureHandlerError": "Vyskytol sa problém s vaším nákupom. Vráťte sa do pokladne a vyberte inú možnosť platby.",
    "CheckoutError": "Vyskytol sa problém. Nákup v pokladni nedokončil.",
    "RdsConsentCancel": "Zrušiť",
    "RdsConsentMicrosoftAccountLabel": "Konto Microsoft",
    "RdsConsentConfirm": "Potvrdiť",
    "RdsConsentWarning": "Ak toto nie je vaše konto, vyberte položku Zrušiť.",
    "RdsConsentTitle": "Potvrďte prepojenie so službou PayPal",
    "RdsConsentRequestError": "Váš výber sa nám nepodarilo spracovať. Skúste to znova."
  },
  "wo": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "it": {
    "SuccessHandlerError": "Il test è stato completato. Tornare al completamento della transazione per completare l'acquisto.",
    "RdsConsentAccountDetailsLabel": "Dettagli account",
    "RdsConsentLead": "Si sta collegando un account PayPal a questo account Microsoft.",
    "CancelHandlerError": "Il test è stato annullato. Torna al completamento della transazione per scegliere un'altra opzione di pagamento.",
    "DeviceFingerprintLoading": "Caricamento",
    "AuthenticatePurchaseInstructions": "Per completare l'acquisto, seguire le istruzioni fornite dalla banca. Attendere. Il caricamento di questa pagina può richiedere 5-10 secondi.",
    "AuthenticatePurchaseHeader": "Autentica acquisto",
    "FailureHandlerError": "Si è verificato un problema durante l'acquisto. Torna al completamento della transazione per scegliere un'altra opzione di pagamento.",
    "CheckoutError": "Si è verificato un errore. Completamento della transazione non andato a buon fine.",
    "RdsConsentCancel": "Annulla",
    "RdsConsentMicrosoftAccountLabel": "Account Microsoft",
    "RdsConsentConfirm": "Conferma",
    "RdsConsentWarning": "Se questo non è l'account personale, selezionare Annulla.",
    "RdsConsentTitle": "Conferma collegamento PayPal",
    "RdsConsentRequestError": "Non è possibile elaborare la scelta. Riprovare."
  },
  "zh-hans": {
    "SuccessHandlerError": "质询完成。返回结帐以完成购买。",
    "RdsConsentAccountDetailsLabel": "帐户详细信息",
    "RdsConsentLead": "你正在将 PayPal 帐户链接到此 Microsoft 帐户。",
    "CancelHandlerError": "已取消质询。返回结帐以选择其他付款选项。",
    "DeviceFingerprintLoading": "正在加载",
    "AuthenticatePurchaseInstructions": "要完成购买，请按照银行提供的说明操作。请稍候。加载此页面可能需要 5-10 秒。",
    "AuthenticatePurchaseHeader": "对购买进行身份验证",
    "FailureHandlerError": "购买时出现问题。返回结帐以选择其他付款选项。",
    "CheckoutError": "出错了。未完成签出。",
    "RdsConsentCancel": "取消",
    "RdsConsentMicrosoftAccountLabel": "Microsoft 帐户",
    "RdsConsentConfirm": "确认",
    "RdsConsentWarning": "如果这不是你的帐户，请选择“取消”。",
    "RdsConsentTitle": "确认 PayPal 链接",
    "RdsConsentRequestError": "我们无法处理你的选择。请重试。"
  },
  "ms": {
    "SuccessHandlerError": "Cabaran selesai. Kembali ke daftar keluar untuk menamatkan pembelian anda.",
    "RdsConsentAccountDetailsLabel": "Butiran akaun",
    "RdsConsentLead": "Anda sedang memautkan akaun PayPal kepada akaun Microsoft ini.",
    "CancelHandlerError": "Cabaran dibatalkan. Kembali ke daftar keluar untuk memilih pilihan pembayaran lain.",
    "DeviceFingerprintLoading": "Memuatkan",
    "AuthenticatePurchaseInstructions": "Untuk melengkapkan pembelian anda, sila ikut arahan yang diberikan oleh bank anda. Sila tunggu. Halaman ini mungkin mengambil masa 5-10 saat untuk dimuatkan.",
    "AuthenticatePurchaseHeader": "Sahkan pembelian anda",
    "FailureHandlerError": "Terdapat masalah dengan pembelian anda. Kembali ke daftar keluar untuk memilih pilihan pembayaran lain.",
    "CheckoutError": "Sesuatu yang tidak kena telah berlaku. Daftar keluar tidak selesai.",
    "RdsConsentCancel": "Batalkan",
    "RdsConsentMicrosoftAccountLabel": "Akaun Microsoft",
    "RdsConsentConfirm": "Sahkan",
    "RdsConsentWarning": "Jika akaun ini bukan milik anda, pilih Batal.",
    "RdsConsentTitle": "Sahkan pautan PayPal anda",
    "RdsConsentRequestError": "Kami tidak dapat memproses pilihan anda. Cuba lagi."
  },
  "tr": {
    "SuccessHandlerError": "Görev tamamlandı. Satın alma işleminizi tamamlamak için ödeme adımına geri dönün.",
    "RdsConsentAccountDetailsLabel": "Hesap ayrıntıları",
    "RdsConsentLead": "Bu Microsoft hesabına bir PayPal hesabı bağlıyorsunuz.",
    "CancelHandlerError": "Görev iptal edildi. Başka bir ödeme seçeneği belirtmek için ödeme adımına geri dönün.",
    "DeviceFingerprintLoading": "Yükleniyor",
    "AuthenticatePurchaseInstructions": "Satın alma işleminizi tamamlamak için bankanızın verdiği yönergeleri izleyin. Lütfen bekleyin. Bu sayfanın yüklenmesi 5-10 saniye sürebilir.",
    "AuthenticatePurchaseHeader": "Satın alma işleminizi doğrulayın",
    "FailureHandlerError": "Satın alma işleminizle ilgili bir sorun oluştu. Başka bir ödeme seçeneği belirtmek için ödeme adımına geri dönün.",
    "CheckoutError": "Bir sorun oluştu. Sonuçlandırma tamamlanmadı.",
    "RdsConsentCancel": "İptal",
    "RdsConsentMicrosoftAccountLabel": "Microsoft hesabı",
    "RdsConsentConfirm": "Onayla",
    "RdsConsentWarning": "Bu sizin hesabınız değilse İptal'i seçin.",
    "RdsConsentTitle": "PayPal bağlantınızı onaylayın",
    "RdsConsentRequestError": "Seçiminiz işlenemedi. Yeniden deneyin."
  },
  "af": {
    "SuccessHandlerError": "Uitdaging is voltooi. Gaan terug na die betaalpunt om jou aankoop te voltooi.",
    "RdsConsentAccountDetailsLabel": "Rekeningbesonderhede",
    "RdsConsentLead": "Jy koppel tans ’n PayPal-rekening aan hierdie Microsoft-rekening.",
    "CancelHandlerError": "Uitdaging is gekanselleer. Gaan terug na die betaalpunt om ’n ander betaalopsie te kies.",
    "DeviceFingerprintLoading": "Laai tans",
    "AuthenticatePurchaseInstructions": "Volg asseblief die instruksies van jou bank om jou aankoop te voltooi. Wag asseblief. Hierdie bladsy kan 5-10 sekondes neem om te laai.",
    "AuthenticatePurchaseHeader": "Waarmerk jou aankoop",
    "FailureHandlerError": "Daar was ’n kwessie met jou aankoop. Gaan terug na die betaalpunt om ’n ander betaalopsie te kies.",
    "CheckoutError": "Iets het skeefgeloop. Betaling is nie voltooi nie.",
    "RdsConsentCancel": "Kanselleer",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-rekening",
    "RdsConsentConfirm": "Bevestig",
    "RdsConsentWarning": "As dit nie jou rekening is nie, kies Kanselleer.",
    "RdsConsentTitle": "Bevestig jou PayPal-skakel",
    "RdsConsentRequestError": "Ons kon nie jou keuse verwerk nie. Probeer weer."
  },
  "hu": {
    "SuccessHandlerError": "Az ellenőrzés kész. A vásárlás befejezéséhez térjen vissza a pénztárhoz.",
    "RdsConsentAccountDetailsLabel": "Fiók adatai",
    "RdsConsentLead": "PayPal-fiókot kapcsol össze ezzel a Microsoft-fiókkal.",
    "CancelHandlerError": "Az ellenőrzés megszakítva. Térjen vissza a pénztárhoz, és válasszon másik fizetési módot.",
    "DeviceFingerprintLoading": "Betöltés folyamatban",
    "AuthenticatePurchaseInstructions": "A vásárlás befejezéséhez kövesse a bankja által megadott utasításokat. Kis türelmet. Ennek az oldalnak a betöltése 5–10 másodpercet is igénybe vehet.",
    "AuthenticatePurchaseHeader": "Hitelesítse a vásárlását",
    "FailureHandlerError": "Probléma adódott a vásárlás során. Térjen vissza a pénztárhoz, és válasszon másik fizetési módot.",
    "CheckoutError": "Hiba történt. A megrendelés nem zárult le.",
    "RdsConsentCancel": "Mégse",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-fiók",
    "RdsConsentConfirm": "Megerősítés",
    "RdsConsentWarning": "Ha ez nem az Ön fiókja, válassza a Mégse lehetőséget.",
    "RdsConsentTitle": "A PayPal-hivatkozás megerősítése",
    "RdsConsentRequestError": "Nem sikerült feldolgozni a választott lehetőséget. Próbálkozzon újra."
  },
  "ro": {
    "SuccessHandlerError": "Provocarea s-a terminat. Reveniți la finalizarea comenzii pentru a încheia achiziția.",
    "RdsConsentAccountDetailsLabel": "Detaliile despre cont",
    "RdsConsentLead": "Legați un cont PayPal la acest cont Microsoft.",
    "CancelHandlerError": "Provocarea a fost anulată. Reveniți la finalizarea comenzii pentru a alege o altă metodă de plată.",
    "DeviceFingerprintLoading": "Se încarcă",
    "AuthenticatePurchaseInstructions": "Pentru a finaliza achiziția, urmați instrucțiunile furnizate de banca dvs. Așteptați. Încărcarea acestei pagini poate dura 5-10 secunde.",
    "AuthenticatePurchaseHeader": "Autentificați achiziția",
    "FailureHandlerError": "A apărut o problemă cu achiziția dvs. Reveniți la finalizarea comenzii pentru a alege o altă metodă de plată.",
    "CheckoutError": "Ceva nu a mers bine. Validare nefinalizată.",
    "RdsConsentCancel": "Anulați",
    "RdsConsentMicrosoftAccountLabel": "Cont Microsoft",
    "RdsConsentConfirm": "Confirmați",
    "RdsConsentWarning": "Dacă acest cont nu vă aparține, selectați Anulați.",
    "RdsConsentTitle": "Confirmați legarea contului PayPal",
    "RdsConsentRequestError": "Nu v-am putut procesa alegerea. Încercați din nou."
  },
  "gd": {
    "SuccessHandlerError": "Chaidh an dùbhlan a choileanadh. Dèan tilleadh is coilean an seacadh a-mach airson a cheannach.",
    "RdsConsentAccountDetailsLabel": "Mion-fhiosrachadh mun chunntas",
    "RdsConsentLead": "Tha thu a’ ceangal cunntas PayPal ris a’ chunntas Microsoft seo.",
    "CancelHandlerError": "Sguireadh dhen dùbhlan. Dèan tilleadh is aig an t-seacadh a-mach, tagh dòigh pàighidh eile.",
    "DeviceFingerprintLoading": "Ga luchdadh",
    "AuthenticatePurchaseInstructions": "Airson a’ cheannachd seo a choileanadh, lean ris an stiùireadh a fhuair thu on bhanca agad. Fuirich ort. Bidh an duilleag seo eadar 5 is 10 diogan ga luchdadh.",
    "AuthenticatePurchaseHeader": "Dearbh na tha thu airson ceannach",
    "FailureHandlerError": "Cha b’ urrainn dhuinn a’ cheannachd a choileanadh. Dèan tilleadh is aig an t-seacadh a-mach, tagh dòigh pàighidh eile.",
    "CheckoutError": "Chaidh rudeigin ceàrr. Cha do choilean an seacadh a-mach.",
    "RdsConsentCancel": "Sguir dheth",
    "RdsConsentMicrosoftAccountLabel": "Cunntas Microsoft",
    "RdsConsentConfirm": "Daingnich",
    "RdsConsentWarning": "Mur e seo an cunntas agadsa, tagh “Sguir dheth”.",
    "RdsConsentTitle": "Daingnich an ceangal PayPal agad",
    "RdsConsentRequestError": "Chan b’ urrainn dhuinn na thagh thu a phròiseasadh. Feuch ris a-rithist."
  },
  "ky": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "quz": {
    "SuccessHandlerError": "Atipayta huntapay. Rantisqaykita tukunaykipaq kutiy cajaman.",
    "RdsConsentAccountDetailsLabel": "Yupaypa detallenkuna",
    "RdsConsentLead": "PayPal yupayta kay Microsoft yupayman tinkichkanki.",
    "CancelHandlerError": "Atipayqa chinkachisqam karqun. Huk qullqi quypaq akllanapaq qullqi quyman kutiy.",
    "DeviceFingerprintLoading": "Churkuchkan",
    "AuthenticatePurchaseInstructions": "Rantisqaykita tukunaykipaqqa, bancoykipa kamachikuyninkunata kasukuy. Ama hina kaspayki suyay. Kay panqaqa 5-10 siqikunatam hapinman kargananpaq.",
    "AuthenticatePurchaseHeader": "Rantisqaykita chiqapchaykuy",
    "FailureHandlerError": "Rantisqaykiwanmi huk sasachakuy karqan. Huk qullqi quypaq akllanapaq qullqi quyman kutiy.",
    "CheckoutError": "Huk pantay ruwakurqa. Rantiy tukunaqa man huntasqa.",
    "RdsConsentCancel": "Sayaykachiy",
    "RdsConsentMicrosoftAccountLabel": "Microsoft yupay",
    "RdsConsentConfirm": "Yuyachiy",
    "RdsConsentWarning": "Sichus kay mana yupayniykichu, akllay Cancelar.",
    "RdsConsentTitle": "PayPal tinkiyniykita chiqapchay",
    "RdsConsentRequestError": "Mana akllasqaykita ruwayta atirqaykuchu. Musuqmanta ruway."
  },
  "es-mx": {
    "SuccessHandlerError": "Desafío completado. Vuelve a la finalización de la compra para completar tu compra.",
    "RdsConsentAccountDetailsLabel": "Detalles de la cuenta",
    "RdsConsentLead": "Estás vinculando una cuenta de PayPal a esta cuenta de Microsoft.",
    "CancelHandlerError": "Desafío cancelado. Vuelve a la finalización de la compra para elegir otra opción de pago.",
    "DeviceFingerprintLoading": "Carga",
    "AuthenticatePurchaseInstructions": "Para completar la compra, sigue las instrucciones que te da tu banco. Espera. Esta página puede tardar entre 5 y 10 segundos en cargarse.",
    "AuthenticatePurchaseHeader": "Autenticar la compra",
    "FailureHandlerError": "Hubo un problema con tu compra. Vuelve a la finalización de la compra para elegir otra opción de pago.",
    "CheckoutError": "Se produjo un error. No se completó la compra.",
    "RdsConsentCancel": "Cancelar",
    "RdsConsentMicrosoftAccountLabel": "Cuenta de Microsoft",
    "RdsConsentConfirm": "Confirmar",
    "RdsConsentWarning": "Si esta no es tu cuenta, selecciona Cancelar.",
    "RdsConsentTitle": "Confirma el vínculo con PayPal",
    "RdsConsentRequestError": "No pudimos procesar tu selección. Inténtalo de nuevo."
  },
  "ti": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "fr": {
    "SuccessHandlerError": "Défi réussi. Revenez au paiement pour finaliser votre achat.",
    "RdsConsentAccountDetailsLabel": "Informations sur le compte",
    "RdsConsentLead": "Vous associez un compte PayPal à ce compte Microsoft.",
    "CancelHandlerError": "Défi annulé. Revenez au paiement pour choisir une autre option de paiement.",
    "DeviceFingerprintLoading": "Chargement",
    "AuthenticatePurchaseInstructions": "Pour finaliser votre achat, veuillez suivre les instructions fournies par votre banque. Veuillez patienter. Le chargement de cette page peut prendre entre 5 et 10 secondes.",
    "AuthenticatePurchaseHeader": "Authentifiez votre achat",
    "FailureHandlerError": "Un problème s’est produit lors de votre achat. Revenez au paiement pour choisir une autre option de paiement.",
    "CheckoutError": "Un problème s’est produit. Le paiement n’a pas abouti.",
    "RdsConsentCancel": "Annuler",
    "RdsConsentMicrosoftAccountLabel": "Compte Microsoft",
    "RdsConsentConfirm": "Confirmer",
    "RdsConsentWarning": "Si ce n’est pas votre compte, sélectionnez Annuler.",
    "RdsConsentTitle": "Confirmez la liaison avec votre compte PayPal",
    "RdsConsentRequestError": "Nous n’avons pas pu traiter votre choix. Réessayez."
  },
  "pa-arab-pk": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "ga": {
    "SuccessHandlerError": "Tá an dúshlán críochnaithe. Fill ar an tseiceáil amach chun do cheannach a chríochnú.",
    "RdsConsentAccountDetailsLabel": "Sonraí an chuntais",
    "RdsConsentLead": "Tá cuntas PayPal á nascadh agat leis an gcuntas Microsoft seo.",
    "CancelHandlerError": "Cealaíodh an dúshlán. Fill ar an tseiceáil amach chun rogha íocaíochta eile a roghnú.",
    "DeviceFingerprintLoading": "Á lódáil",
    "AuthenticatePurchaseInstructions": "Chun do cheannach a chríochnú, lean na treoracha a chuireann an banc ar fáil. Fan, le do thoil. Is féidir leis an leathanach seo 5-10 soicind a thógadh le lódáil.",
    "AuthenticatePurchaseHeader": "Fíordheimhnigh do cheannachán",
    "FailureHandlerError": "Bhí fadhb le do cheannach. Fill ar an tseiceáil amach chun rogha íocaíochta eile a roghnú.",
    "CheckoutError": "Bhí fadhb againn. Níl an tseiceáil amach críochnaithe.",
    "RdsConsentCancel": "Cealaigh",
    "RdsConsentMicrosoftAccountLabel": "Cuntas Microsoft",
    "RdsConsentConfirm": "Deimhnigh",
    "RdsConsentWarning": "Murab é seo do chuntas, roghnaigh Cealaigh.",
    "RdsConsentTitle": "Deimhnigh do nasc PayPal",
    "RdsConsentRequestError": "Níorbh fhéidir linn do rogha a phróiseáil. Bain triail eile as."
  },
  "hr": {
    "SuccessHandlerError": "Izazov je završen. Vratite se na završetak kupnje kako biste dovršili kupnju.",
    "RdsConsentAccountDetailsLabel": "Pojedinosti o računu",
    "RdsConsentLead": "Povezujete račun za PayPal s ovim Microsoftovim računom.",
    "CancelHandlerError": "Izazov je otkazan. Vratite se na završetak kupnje kako biste odabrali drugi način plaćanja.",
    "DeviceFingerprintLoading": "Učitavanje",
    "AuthenticatePurchaseInstructions": "Da biste dovršili kupnju, slijedite upute koje vam je dala banka. Pričekajte. Učitavanje ove stranice može potrajati 5 – 10 sekundi.",
    "AuthenticatePurchaseHeader": "Potvrdite svoju kupnju",
    "FailureHandlerError": "Pojavio se problem s kupnjom. Vratite se na završetak kupnje kako biste odabrali drugi način plaćanja.",
    "CheckoutError": "Došlo je do pogreške. Odjava nije dovršena.",
    "RdsConsentCancel": "Odustani",
    "RdsConsentMicrosoftAccountLabel": "Microsoftov račun",
    "RdsConsentConfirm": "Potvrdi",
    "RdsConsentWarning": "Ako ovo nije vaš račun, odaberite Odustani.",
    "RdsConsentTitle": "Potvrdite povezivanje s PayPalom",
    "RdsConsentRequestError": "Nismo uspjeli obraditi vaš odabir. Pokušajte ponovno."
  },
  "ru": {
    "SuccessHandlerError": "Испытание выполнено. Вернитесь к оформлению заказа, чтобы завершить покупку.",
    "RdsConsentAccountDetailsLabel": "Сведения об учетной записи",
    "RdsConsentLead": "Вы связываете учетную запись PayPal с этой учетной записью Майкрософт.",
    "CancelHandlerError": "Испытание отменено. Вернитесь к оформлению заказа, чтобы выбрать другой способ платежа.",
    "DeviceFingerprintLoading": "Загрузка",
    "AuthenticatePurchaseInstructions": "Чтобы завершить покупку, следуйте инструкциям вашего банка. Подождите. Загрузка этой страницы может занять 5–10 секунд.",
    "AuthenticatePurchaseHeader": "Подтверждение покупки",
    "FailureHandlerError": "Возникла проблема с вашей покупкой. Вернитесь к оформлению заказа, чтобы выбрать другой способ платежа.",
    "CheckoutError": "Произошла ошибка. Извлечение не завершено.",
    "RdsConsentCancel": "Отменить",
    "RdsConsentMicrosoftAccountLabel": "Учетная запись Майкрософт",
    "RdsConsentConfirm": "Подтвердить",
    "RdsConsentWarning": "Если это не ваша учетная запись, выберите «Отменить».",
    "RdsConsentTitle": "Подтвердите подключение к PayPal",
    "RdsConsentRequestError": "Не удалось обработать ваш выбор. Повторите попытку."
  },
  "yo": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "mt": {
    "SuccessHandlerError": "L-isfida tlestiet. Mur lura fiċ-checkout biex tlesti x-xirja tiegħek.",
    "RdsConsentAccountDetailsLabel": "Dettalji tal-kont",
    "RdsConsentLead": "Qed tillinkja kont ta’ PayPal ma’ dan il-kont ta’ Microsoft.",
    "CancelHandlerError": "L-isfida ġiet ikkanċellata. Mur lura fiċ-checkout biex tagħżel għażla tal-ħlas oħra.",
    "DeviceFingerprintLoading": "Qed jillowdja",
    "AuthenticatePurchaseInstructions": "Biex tlesti x-xirja tiegħek, segwi l-istruzzjonijiet ipprovduti mill-bank tiegħek. Stenna. Din il-paġna tista’ tieħu 5-10 sekondi biex tillowdja.",
    "AuthenticatePurchaseHeader": "Awtentika x-xirja tiegħek",
    "FailureHandlerError": "Kien hemm problema bix-xirja tiegħek. Mur lura fiċ-checkout biex tagħżel għażla tal-ħlas oħra.",
    "CheckoutError": "Ġrat xi ħaġa ħażina. Iċ-checkout ma tlestiex.",
    "RdsConsentCancel": "Ikkanċella",
    "RdsConsentMicrosoftAccountLabel": "Kont ta’ Microsoft",
    "RdsConsentConfirm": "Ikkonferma",
    "RdsConsentWarning": "Jekk dan mhux il-kont tiegħek, agħżel Ikkanċella.",
    "RdsConsentTitle": "Ikkonferma l-link ta’ PayPal tiegħek",
    "RdsConsentRequestError": "Ma stajniex nipproċessaw l-għażla tiegħek. Erġa’ pprova."
  },
  "pa-in": {
    "SuccessHandlerError": "ਚੈਲੇਂਜ ਪੂਰਾ ਹੋਇਆ। ਆਪਣੀ ਖਰੀਦ ਨੂੰ ਪੂਰਾ ਕਰਨ ਲਈ ਚੈੱਕਆਉਟ 'ਤੇ ਵਾਪਸ ਜਾਓ।",
    "RdsConsentAccountDetailsLabel": "ਖਾਤੇ ਦੇ ਵੇਰਵੇ",
    "RdsConsentLead": "ਤੁਸੀਂ ਇੱਕ PayPal ਖਾਤੇ ਨੂੰ ਇਸ Microsoft ਖਾਤੇ ਨਾਲ ਲਿੰਕ ਕਰ ਰਹੇ ਹੋ।",
    "CancelHandlerError": "ਚੈਲੇਂਜ ਰੱਦ ਕੀਤਾ ਗਿਆ। ਕੋਈ ਹੋਰ ਭੁਗਤਾਨ ਵਿਕਲਪ ਚੁਣਨ ਲਈ ਚੈੱਕਆਉਟ 'ਤੇ ਵਾਪਸ ਜਾਓ।",
    "DeviceFingerprintLoading": "ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ",
    "AuthenticatePurchaseInstructions": "ਆਪਣੀ ਖਰੀਦ ਨੂੰ ਪੂਰਾ ਕਰਨ ਲਈ, ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਬੈਂਕ ਵੱਲੋਂ ਦਿੱਤੇ ਨਿਰਦੇਸ਼ਾਂ ਦੀ ਪਾਲਣਾ ਕਰੋ। ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ। ਇਸ ਪੰਨੇ ਨੂੰ ਲੋਡ ਹੋਣ ਵਿੱਚ 5-10 ਸਕਿੰਟ ਲੱਗ ਸਕਦੇ ਹਨ।",
    "AuthenticatePurchaseHeader": "ਆਪਣੀ ਖਰੀਦ ਨੂੰ ਪ੍ਰਮਾਣਿਤ ਕਰੋ",
    "FailureHandlerError": "ਤੁਹਾਡੀ ਖਰੀਦ ਵਿੱਚ ਸਮੱਸਿਆ ਆਈ ਸੀ। ਕੋਈ ਹੋਰ ਭੁਗਤਾਨ ਵਿਕਲਪ ਚੁਣਨ ਲਈ ਚੈੱਕਆਉਟ 'ਤੇ ਵਾਪਸ ਜਾਓ।",
    "CheckoutError": "ਕੁਝ ਗੜਬੜ ਹੋ ਗਈ। ਭੁਗਤਾਨ ਕਰਨਾ ਪੂਰਾ ਨਹੀਂ ਹੋਇਆ।",
    "RdsConsentCancel": "ਰੱਦ ਕਰੋ",
    "RdsConsentMicrosoftAccountLabel": "Microsoft ਖਾਤਾ",
    "RdsConsentConfirm": "ਪੁਸ਼ਟੀ ਕਰੋ",
    "RdsConsentWarning": "ਜੇ ਇਹ ਤੁਹਾਡਾ ਖਾਤਾ ਨਹੀਂ ਹੈ, ਤਾਂ ਰੱਦ ਕਰੋ ਦੀ ਚੋਣ ਕਰੋ।",
    "RdsConsentTitle": "ਆਪਣੇ PayPal ਲਿੰਕ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
    "RdsConsentRequestError": "ਅਸੀਂ ਤੁਹਾਡੀ ਚੋਣ 'ਤੇ ਪ੍ਰਕਿਰਿਆ ਨਹੀਂ ਕਰ ਸਕੇ। ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।"
  },
  "tg": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "ar": {
    "SuccessHandlerError": "اكتمل التحدي. عد إلى صفحة السداد مع الخروج لإتمام عملية الشراء لديك.",
    "RdsConsentAccountDetailsLabel": "تفاصيل الحساب",
    "RdsConsentLead": "أنت تقوم بربط حساب PayPal بحساب Microsoft هذا.",
    "CancelHandlerError": "تم إلغاء التحدي. عد إلى صفحة السداد مع الخروج لاختيار خيار دفع آخر.",
    "DeviceFingerprintLoading": "جاري التحميل",
    "AuthenticatePurchaseInstructions": "لإكمال عملية الشراء، يرجى اتباع التعليمات التي يزودك بها البنك. الرجاء الانتظار. قد تستغرق هذه الصفحة من 5 إلى 10 ثوانٍ للتحميل.",
    "AuthenticatePurchaseHeader": "مصادقة عملية الشراء خاصتك",
    "FailureHandlerError": "حدثت مشكلة في عملية الشراء لديك. عد إلى صفحة السداد مع الخروج لاختيار خيار دفع آخر.",
    "CheckoutError": "حدث خطأ ما. لم يكتمل السداد مع الخروج.",
    "RdsConsentCancel": "إلغاء",
    "RdsConsentMicrosoftAccountLabel": "حساب Microsoft",
    "RdsConsentConfirm": "تأكيد",
    "RdsConsentWarning": "إذا لم يكن هذا هو حسابك، فحدد \"إلغاء الأمر\".",
    "RdsConsentTitle": "تأكيد ارتباط PayPal الخاص بك",
    "RdsConsentRequestError": "تعذرت معالجة اختيارك. حاول مرة أخرى."
  },
  "uz": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "pt-br": {
    "SuccessHandlerError": "Desafio concluído. Retorne ao check-out para concluir sua compra.",
    "RdsConsentAccountDetailsLabel": "Detalhes da conta",
    "RdsConsentLead": "Você está vinculando uma conta do PayPal a esta conta Microsoft.",
    "CancelHandlerError": "Desafio cancelado. Retorne ao check-out para escolher outra opção de pagamento.",
    "DeviceFingerprintLoading": "Carregando",
    "AuthenticatePurchaseInstructions": "Para concluir sua compra, siga as instruções fornecidas pelo seu banco. Aguarde. Esta página pode levar de 5 a 10 segundos para ser carregada.",
    "AuthenticatePurchaseHeader": "Autentique sua compra",
    "FailureHandlerError": "Houve um problema com sua compra. Retorne ao check-out para escolher outra opção de pagamento.",
    "CheckoutError": "Algo deu errado. Check-out não concluído.",
    "RdsConsentCancel": "Cancelar",
    "RdsConsentMicrosoftAccountLabel": "Conta Microsoft",
    "RdsConsentConfirm": "Confirmar",
    "RdsConsentWarning": "Se esta não for sua conta, selecione Cancelar.",
    "RdsConsentTitle": "Confirme seu vínculo com o PayPal",
    "RdsConsentRequestError": "Não foi possível processar sua escolha. Tente novamente."
  },
  "zh-hant": {
    "SuccessHandlerError": "挑戰完成。請返回結帳以完成購買。",
    "RdsConsentAccountDetailsLabel": "帳戶詳細資料",
    "RdsConsentLead": "您正在將 PayPal 帳戶連結至此 Microsoft 帳戶。",
    "CancelHandlerError": "挑戰已取消。請返回結帳以選擇其他付款方式。",
    "DeviceFingerprintLoading": "正在載入",
    "AuthenticatePurchaseInstructions": "要完成購買，請依照銀行提供的指示操作。請稍候。此頁面可能需要 5 至 10 秒才能載入。",
    "AuthenticatePurchaseHeader": "驗證您的購買",
    "FailureHandlerError": "您的購買發生問題。請返回結帳以選擇其他付款方式。",
    "CheckoutError": "發生問題。結帳未完成。",
    "RdsConsentCancel": "取消",
    "RdsConsentMicrosoftAccountLabel": "Microsoft 帳戶",
    "RdsConsentConfirm": "確認",
    "RdsConsentWarning": "如果這不是您的帳戶，請選取 [取消]。",
    "RdsConsentTitle": "確認您的 PayPal 連結",
    "RdsConsentRequestError": "我們無法處理您的選擇。請再試一次。"
  },
  "as": {
    "SuccessHandlerError": "প্ৰত্যাহ্বান সম্পূৰ্ণ হৈছে। আপোনাৰ ক্ৰয় সম্পূৰ্ণ কৰিবলৈ চেকআউটলৈ উভতি যাওক।",
    "RdsConsentAccountDetailsLabel": "একাউণ্টৰ সবিশেষ",
    "RdsConsentLead": "আপুনি এই Microsoft একাউণ্টটোৰ সৈতে PayPal একাউণ্ট এটা লিংকিং কৰি আছে।",
    "CancelHandlerError": "প্ৰত্যাহ্বান বাতিল কৰা হৈছে। অন্য পৰিশোধ বিকল্প বাছনি কৰিবলৈ চেকআউটলৈ উভতি যাওক।",
    "DeviceFingerprintLoading": "ল’ড হৈ আছে",
    "AuthenticatePurchaseInstructions": "আপোনাৰ ক্ৰয় সম্পূৰ্ণ কৰিবলৈ, অনুগ্ৰহ কৰি আপোনাৰ বেংকৰ নিৰ্দেশনা অনুসৰণ কৰক। অনুগ্ৰহ কৰি অপেক্ষা কৰক। এই পৃষ্ঠাটো লোড হ'বলৈ 5-10 ছেকেণ্ড সময় লাগিব পাৰে।",
    "AuthenticatePurchaseHeader": "আপোনাৰ ক্ৰয় প্ৰমাণিত কৰক",
    "FailureHandlerError": "আপোনাৰ ক্ৰয়ত সমস্যা হৈছিল। অন্য পৰিশোধ বিকল্প বাছনি কৰিবলৈ চেকআউটলৈ উভতি যাওক।",
    "CheckoutError": "কিবা ভুল হৈছে। চ্চেকআউট সম্পূৰ্ণ হোৱা নাই।",
    "RdsConsentCancel": "বাতিল কৰক",
    "RdsConsentMicrosoftAccountLabel": "Microsoft একাউণ্ট",
    "RdsConsentConfirm": "নিশ্চিত কৰক",
    "RdsConsentWarning": "যদি এইটো আপোনাৰ একাউণ্ট নহয়, বাতিল কৰক চয়ন কৰক।",
    "RdsConsentTitle": "আপোনাৰ PayPal লিংক নিশ্চিত কৰক",
    "RdsConsentRequestError": "আমি আপোনাৰ পচন্দৰ প্ৰক্ৰিয়া চলাব নোৱাৰিলোঁ। পুনৰাই চেষ্টা কৰক।"
  },
  "bg": {
    "SuccessHandlerError": "Предизвикателството е завършено. Върнете се към финализирането, за да завършите покупката си.",
    "RdsConsentAccountDetailsLabel": "Подробни данни за акаунта",
    "RdsConsentLead": "Свързвате акаунт в PayPal с този акаунт в Microsoft.",
    "CancelHandlerError": "Предизвикателството е отменено. Върнете се към финализирането, за да изберете друга опция за плащане.",
    "DeviceFingerprintLoading": "Зареждане",
    "AuthenticatePurchaseInstructions": "За да завършите покупката си, следвайте инструкциите, предоставени от вашата банка. Моля, изчакайте. Зареждането на тази страница може да отнеме 5-10 секунди.",
    "AuthenticatePurchaseHeader": "Удостоверете покупката си",
    "FailureHandlerError": "Възникна проблем с вашата покупка. Върнете се към финализирането, за да изберете друга опция за плащане.",
    "CheckoutError": "Възникна проблем. Финализирането не е завършено.",
    "RdsConsentCancel": "Отменяне",
    "RdsConsentMicrosoftAccountLabel": "Акаунт в Microsoft",
    "RdsConsentConfirm": "Потвърждавам",
    "RdsConsentWarning": "Ако това не е вашият акаунт, изберете „Отказ“.",
    "RdsConsentTitle": "Потвърдете вашата връзка за PayPal",
    "RdsConsentRequestError": "Обработката на вашата заявка е неуспешна. Опитайте отново."
  },
  "kn": {
    "SuccessHandlerError": "ಸವಾಲು ಪೂರ್ಣಗೊಂಡಿದೆ. ನಿಮ್ಮ ಖರೀದಿಯನ್ನು ಮುಗಿಸಲು ಚೆಕ್ಔಟ್‌ಗೆ ಹಿಂತಿರುಗಿ.",
    "RdsConsentAccountDetailsLabel": "ಖಾತೆ ವಿವರಗಳು",
    "RdsConsentLead": "ನೀವು ಈ Microsoft ಖಾತೆಗೆ PayPal ಖಾತೆಯನ್ನು ಲಿಂಕ್ ಮಾಡುತ್ತಿದ್ದೀರಿ.",
    "CancelHandlerError": "ಸವಾಲು ರದ್ದುಗೊಂಡಿದೆ. ಮತ್ತೊಂದು ಪಾವತಿ ಆಯ್ಕೆಯನ್ನು ಆರಿಸಲು ಚೆಕ್ಔಟ್‌ಗೆ ಹಿಂತಿರುಗಿ.",
    "DeviceFingerprintLoading": "ಲೋಡ್ ಆಗುತ್ತಿದೆ",
    "AuthenticatePurchaseInstructions": "ನಿಮ್ಮ ಖರೀದಿಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು, ದಯವಿಟ್ಟು ನಿಮ್ಮ ಬ್ಯಾಂಕ್ ನೀಡಿದ ಸೂಚನೆಗಳನ್ನು ಅನುಸರಿಸಿ. ದಯವಿಟ್ಟು ನಿರೀಕ್ಷಿಸಿ. ಈ ಪುಟ ಲೋಡ್ ಆಗಲು 5-10 ಸೆಕೆಂಡುಗಳ ಸಮಯ ತೆಗೆದುಕೊಳ್ಳಬಹುದು.",
    "AuthenticatePurchaseHeader": "ನಿಮ್ಮ ಖರೀದಿಯನ್ನು ದೃಢೀಕರಿಸಿ",
    "FailureHandlerError": "ನಿಮ್ಮ ಖರೀದಿಯಲ್ಲಿ ಸಮಸ್ಯೆ ಉಂಟಾಗಿದೆ. ಮತ್ತೊಂದು ಪಾವತಿ ಆಯ್ಕೆಯನ್ನು ಆರಿಸಲು ಚೆಕ್ಔಟ್‌ಗೆ ಹಿಂತಿರುಗಿ.",
    "CheckoutError": "ಏನೋ ತಪ್ಪು ಸಂಭವಿಸಿದೆ. ಚೆಕ್ಔಟ್ ಪೂರ್ಣಗೊಳಿಸಲಾಗಿಲ್ಲ.",
    "RdsConsentCancel": "ರದ್ದುಮಾಡಿ",
    "RdsConsentMicrosoftAccountLabel": "Microsoft ಖಾತೆ",
    "RdsConsentConfirm": "ದೃಢೀಕರಿಸಿ",
    "RdsConsentWarning": "ಇದು ನಿಮ್ಮ ಖಾತೆಯಲ್ಲದಿದ್ದರೆ, ರದ್ದು ಆಯ್ಕೆಮಾಡಿ.",
    "RdsConsentTitle": "ನಿಮ್ಮ PayPal ಲಿಂಕ್ ದೃಢಪಡಿಸಿ",
    "RdsConsentRequestError": "ನಿಮ್ಮ ಆಯ್ಕೆಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲು ನಮಗೆ ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ. ಮತ್ತೊಮ್ಮೆ ಪ್ರಯತ್ನಿಸಿ."
  },
  "km": {
    "SuccessHandlerError": "ការប្រកួតប្រជែងបានបញ្ចប់។ សូមត្រឡប់ទៅទំព័រទូទាត់វិញ ដើម្បីបញ្ចប់ការទិញរបស់អ្នក។",
    "RdsConsentAccountDetailsLabel": "ព័ត៌មានលម្អិតអំពីគណនី",
    "RdsConsentLead": "អ្នកកំពុងភ្ជាប់គណនី PayPal ទៅនឹងគណនី Microsoft នេះ។",
    "CancelHandlerError": "ការប្រកួតប្រជែងត្រូវបានបោះបង់។ សូមត្រឡប់ទៅទំព័រទូទាត់វិញ ដើម្បីជ្រើសរើសជម្រើសបង់ប្រាក់ផ្សេងទៀត។",
    "DeviceFingerprintLoading": "កំពុងទាញ",
    "AuthenticatePurchaseInstructions": "ដើម្បីបញ្ចប់ការទិញរបស់អ្នក សូមអនុវត្តតាមការណែនាំដែលធនាគាររបស់អ្នកផ្ដល់ជូន។ សូមរង់ចាំ។ ទំព័រនេះអាចចំណាយពេល 5-10 វិនាទីក្នុងការទាញ។",
    "AuthenticatePurchaseHeader": "ផ្ទៀងផ្ទាត់ការទិញរបស់អ្នក",
    "FailureHandlerError": "មានបញ្ហាក្នុងការទិញរបស់អ្នក។ សូមត្រឡប់ទៅទំព័រទូទាត់វិញ ដើម្បីជ្រើសរើសជម្រើសបង់ប្រាក់ផ្សេងទៀត។",
    "CheckoutError": "មានអ្វីមួយខុសប្រក្រតី។ ការបង់ប្រាក់ចេញមិនត្រូវបានបញ្ចប់ទេ។",
    "RdsConsentCancel": "បោះបង់",
    "RdsConsentMicrosoftAccountLabel": "គណនី Microsoft",
    "RdsConsentConfirm": "បញ្ជាក់",
    "RdsConsentWarning": "ប្រសិនបើមិនមែនជាគណនីរបស់អ្នកទេ សូមជ្រើសរើសបោះបង់។",
    "RdsConsentTitle": "បញ្ជាក់តំណ PayPal របស់អ្នក",
    "RdsConsentRequestError": "យើងមិនអាចដំណើរការជម្រើសរបស់អ្នកបានទេ។ សូមព្យាយាមម្ដងទៀត។"
  },
  "si": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "lt": {
    "SuccessHandlerError": "Saugos užduotis atlikta. Grįžkite į atsiskaitymą, kad užbaigtumėte pirkimą.",
    "RdsConsentAccountDetailsLabel": "Išsami paskyros informacija",
    "RdsConsentLead": "Susiejate „PayPal“ paskyrą su šia „Microsoft“ paskyra.",
    "CancelHandlerError": "Saugos užduotis atšaukta. Grįžkite į atsiskaitymą ir pasirinkite kitą mokėjimo būdą.",
    "DeviceFingerprintLoading": "Įkeliama",
    "AuthenticatePurchaseInstructions": "Norėdami užbaigti pirkimą, vykdykite banko pateiktas instrukcijas. Palaukite. Šio puslapio įkėlimas gali užtrukti 5–10 sekundžių.",
    "AuthenticatePurchaseHeader": "Autentifikuokite pirkimą",
    "FailureHandlerError": "Įvyko problema su jūsų pirkimu. Grįžkite į atsiskaitymą ir pasirinkite kitą mokėjimo būdą.",
    "CheckoutError": "Įvyko klaida. Pirkimo užbaigimas nebaigtas.",
    "RdsConsentCancel": "Atšaukti",
    "RdsConsentMicrosoftAccountLabel": "„Microsoft“ paskyra",
    "RdsConsentConfirm": "Patvirtinti",
    "RdsConsentWarning": "Jei tai ne jūsų paskyra, pasirinkite „Atšaukti“.",
    "RdsConsentTitle": "Patvirtinkite savo „PayPal“ saitą",
    "RdsConsentRequestError": "Nepavyko apdoroti jūsų pasirinkimo. Bandykite dar kartą."
  },
  "lv": {
    "SuccessHandlerError": "Izaicinājums pabeigts. Atgriezieties pie norēķināšanās, lai pabeigtu pirkumu.",
    "RdsConsentAccountDetailsLabel": "Detalizēta informācija par kontu",
    "RdsConsentLead": "Jūs saistāt PayPal kontu ar šo Microsoft kontu.",
    "CancelHandlerError": "Izaicinājums atcelts. Atgriezieties pie norēķināšanās, lai izvēlētos citu maksājuma variantu.",
    "DeviceFingerprintLoading": "Notiek ielāde",
    "AuthenticatePurchaseInstructions": "Lai pabeigtu pirkumu, lūdzu, izpildiet bankas sniegtos norādījumus. Lūdzu, uzgaidiet. Šīs lapas ielāde var ilgt 5–10 sekundes.",
    "AuthenticatePurchaseHeader": "Autentificējiet savu pirkumu",
    "FailureHandlerError": "Radās problēma ar jūsu pirkumu. Atgriezieties pie norēķināšanās, lai izvēlētos citu maksājuma variantu.",
    "CheckoutError": "Notika kļūda. Norēķināšanās nav pabeigta.",
    "RdsConsentCancel": "Atcelt",
    "RdsConsentMicrosoftAccountLabel": "Microsoft konts",
    "RdsConsentConfirm": "Apstiprināt",
    "RdsConsentWarning": "Ja šis nav jūsu konts, atlasiet Atcelt.",
    "RdsConsentTitle": "Apstipriniet savu PayPal saiti",
    "RdsConsentRequestError": "Neizdevās apstrādāt jūsu izvēli. Mēģiniet vēlreiz."
  },
  "bn-bd": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "sv": {
    "SuccessHandlerError": "Utmaningen har slutförts. Gå tillbaka till kassan för att slutföra köpet.",
    "RdsConsentAccountDetailsLabel": "Kontouppgifter",
    "RdsConsentLead": "Du länkar ett PayPal-konto till det här Microsoft-kontot.",
    "CancelHandlerError": "Utmaningen har avbrutits. Gå tillbaka till kassan och välj ett annat betalningsalternativ.",
    "DeviceFingerprintLoading": "Läser in",
    "AuthenticatePurchaseInstructions": "Slutför köpet genom att följa anvisningarna från din bank. Vänta. Den här sidan kan ta 5–10 sekunder att läsa in.",
    "AuthenticatePurchaseHeader": "Autentisera ditt köp",
    "FailureHandlerError": "Det uppstod ett problem med ditt köp. Gå tillbaka till kassan och välj ett annat betalningsalternativ.",
    "CheckoutError": "Något gick fel. Utcheckningen inte slutförd.",
    "RdsConsentCancel": "Avbryt",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-konto",
    "RdsConsentConfirm": "Bekräfta",
    "RdsConsentWarning": "Välj Avbryt om det här inte är ditt konto.",
    "RdsConsentTitle": "Bekräfta din PayPal-länk",
    "RdsConsentRequestError": "Det gick inte att behandla ditt val. Försök igen."
  },
  "ha": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "he": {
    "SuccessHandlerError": "האתגר הושלם. חזור לדף התשלום כדי לסיים את הרכישה.",
    "RdsConsentAccountDetailsLabel": "פרטי חשבון",
    "RdsConsentLead": "פעולה זו שלך מקשרת את חשבון PayPal לחשבון Microsoft הזה.",
    "CancelHandlerError": "האתגר בוטל. חזור לתשלום כדי לבחור אפשרות תשלום אחרת.",
    "DeviceFingerprintLoading": "בטעינה",
    "AuthenticatePurchaseInstructions": "כדי להשלים את הרכישה, עקוב אחר ההוראות שקיבלת מהבנק. המתן. טעינת הדף עשויה להימשך 5-‏10 שניות.",
    "AuthenticatePurchaseHeader": "אימות הרכישה",
    "FailureHandlerError": "אירעה בעיה ברכישה שלך. חזור לתשלום כדי לבחור אפשרות תשלום אחרת.",
    "CheckoutError": "משהו השתבש. התשלום לא הושלם.",
    "RdsConsentCancel": "ביטול",
    "RdsConsentMicrosoftAccountLabel": "חשבון Microsoft",
    "RdsConsentConfirm": "אישור",
    "RdsConsentWarning": "אם זה אינו החשבון שלך, יש לבחור באפשרות 'ביטול'.",
    "RdsConsentTitle": "אישור קישור של ה- PayPal שלך",
    "RdsConsentRequestError": "לא הצלחנו לעבד את הבחירה שלך. כדאי לנסות שוב."
  },
  "uk": {
    "SuccessHandlerError": "Перевірку завершено. Поверніться до оформлення замовлення, щоб завершити покупку.",
    "RdsConsentAccountDetailsLabel": "Відомості про обліковий запис",
    "RdsConsentLead": "Ви пов’язуєте обліковий запис PayPal із цим обліковим записом Microsoft.",
    "CancelHandlerError": "Перевірку скасовано. Поверніться до оформлення замовлення, щоб вибрати інший спосіб оплати.",
    "DeviceFingerprintLoading": "Завантаження",
    "AuthenticatePurchaseInstructions": "Щоб завершити покупку, дотримуйтесь інструкцій, наданих вашим банком. Зачекайте. Завантаження цієї сторінки може тривати 5–10 секунд.",
    "AuthenticatePurchaseHeader": "Підтвердьте покупку",
    "FailureHandlerError": "Виникла проблема з покупкою. Поверніться до оформлення замовлення, щоб вибрати інший спосіб оплати.",
    "CheckoutError": "Сталася помилка. Взяття на редагування не завершено.",
    "RdsConsentCancel": "Скасувати",
    "RdsConsentMicrosoftAccountLabel": "Обліковий запис Microsoft",
    "RdsConsentConfirm": "Підтвердити",
    "RdsConsentWarning": "Якщо це не ваш обліковий запис, натисніть \"Скасувати\".",
    "RdsConsentTitle": "Підтвердьте зв’язок із PayPal",
    "RdsConsentRequestError": "Не вдалось обробити ваш вибір. Спробуйте знову."
  },
  "zu": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "or": {
    "SuccessHandlerError": "ଚ୍ୟାଲେଞ୍ଜ୍ ସମ୍ପୂର୍ଣ୍ଣ ହୋଇଛି । ଆପଣଙ୍କ କ୍ରୟ ଶେଷ କରିବାକୁ ଚେକ୍‍‌ଆଉଟ୍‌କୁ ଫେରନ୍ତୁ ।",
    "RdsConsentAccountDetailsLabel": "ଏକାଉଣ୍ଟ୍ ବିବରଣୀ",
    "RdsConsentLead": "ଆପଣ ଏହି Microsoft ଏକାଉଣ୍ଟ୍ ସହିତ ଏକ PayPal ଏକାଉଣ୍ଟ୍ ଲିଙ୍କ୍ କରୁଛନ୍ତି ।",
    "CancelHandlerError": "ଚ୍ୟାଲେଞ୍ଜ୍ ବାତିଲ୍ ହୋଇଛି । ଅନ୍ୟ ଏକ ଦେୟ ବିକଳ୍ପ ମନୋନୟନ କରିବା ପାଇଁ ଚେକ୍‍‌ଆଉଟ୍‌କୁ ଫେରନ୍ତୁ ।",
    "DeviceFingerprintLoading": "ଲୋଡ୍ ହେଉଛି",
    "AuthenticatePurchaseInstructions": "ଆପଣଙ୍କର କ୍ରୟ ସମ୍ପୂର୍ଣ୍ଣ କରିବାକୁ, ଦୟାକରି ଆପଣଙ୍କ ବ୍ୟାଙ୍କ ଦ୍ୱାରା ପ୍ରଦାନ କରାଯାଇଥିବା ନିର୍ଦ୍ଦେଶାବଳୀ ଅନୁସରଣ କରନ୍ତୁ । ଦୟାକରି ଅପେକ୍ଷା କରନ୍ତୁ । ଏହି ପୃଷ୍ଠା ଲୋଡ୍ ହେବା ପାଇଁ 5-10 ସେକେଣ୍ଡ ସମୟ ଲାଗିପାରେ ।",
    "AuthenticatePurchaseHeader": "ଆପଣଙ୍କ କ୍ରୟ ପ୍ରାମାଣିକ କରନ୍ତୁ",
    "FailureHandlerError": "ଆପଣଙ୍କର କ୍ରୟରେ ଏକ ସମସ୍ୟା ହୋଇଛି । ଅନ୍ୟ ଏକ ଦେୟ ବିକଳ୍ପ ମନୋନୟନ କରିବା ପାଇଁ ଚେକ୍‍‌ଆଉଟ୍‌କୁ ଫେରନ୍ତୁ ।",
    "CheckoutError": "କିଛି ଭୁଲ୍ ହୋଇଛି. ସଂପୂର୍ଣ୍ଣ ଚେକ୍‌ଆଉଟ୍‍‌ ହୋଇନାହି.",
    "RdsConsentCancel": "ବାତିଲ୍ କରନ୍ତୁ",
    "RdsConsentMicrosoftAccountLabel": "Microsoft ଏକାଉଣ୍ଟ୍",
    "RdsConsentConfirm": "ସୁନିଶ୍ଚିତ କରନ୍ତୁ",
    "RdsConsentWarning": "ଯଦି ଏହା ଆପଣଙ୍କର ଏକାଉଣ୍ଟ୍ ନୁହେଁ, ତେବେ “ବାତିଲ୍ କରନ୍ତୁ” ଚୟନ କରନ୍ତୁ ।",
    "RdsConsentTitle": "ଆପଣଙ୍କ PayPal ଲିଙ୍କ୍ ସୁନିଶ୍ଚିତ କରନ୍ତୁ",
    "RdsConsentRequestError": "ଆମେ ଆପଣଙ୍କ ପସନ୍ଦ ପ୍ରୋସେସ୍ କରିପାରିଲୁ ନାହିଁ । ଦୟାକରି ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ ।"
  },
  "ca": {
    "SuccessHandlerError": "Repte completat. Torna a la pàgina per finalitzar la compra.",
    "RdsConsentAccountDetailsLabel": "Detalls del compte",
    "RdsConsentLead": "Esteu enllaçant un compte de PayPal a aquest compte de Microsoft.",
    "CancelHandlerError": "Repte cancel·lat. Torna a la compra per triar una altra opció de pagament.",
    "DeviceFingerprintLoading": "S'està carregant",
    "AuthenticatePurchaseInstructions": "Per completar la compra, seguiu les instruccions que ha proporcionat el banc. Espereu. Aquesta pàgina pot trigar entre 5 i 10 segons a carregar-se.",
    "AuthenticatePurchaseHeader": "Autentiqueu la compra",
    "FailureHandlerError": "Hi ha hagut un problema amb la compra. Torna a la compra per triar una altra opció de pagament.",
    "CheckoutError": "S'ha produït un error. No s'ha finalitzat la compra.",
    "RdsConsentCancel": "Cancel·la",
    "RdsConsentMicrosoftAccountLabel": "Compte de Microsoft",
    "RdsConsentConfirm": "Confirma",
    "RdsConsentWarning": "Si aquest compte no és vostre, seleccioneu Cancel·la.",
    "RdsConsentTitle": "Confirmeu l'enllaç de PayPal",
    "RdsConsentRequestError": "No hem pogut processar la vostra sol·licitud. Torneu-ho a provar."
  },
  "sd": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "mi": {
    "SuccessHandlerError": "Kua oti te wero. Hoki ki te taki atu ki te whakaoti i tō hoko.",
    "RdsConsentAccountDetailsLabel": "He taipitopito pūkete",
    "RdsConsentLead": "Kei te honoa e koe tētahi pūkete PayPal ki tēnei pūkete Microsoft.",
    "CancelHandlerError": "Kua whakakorea te wero. Hoki ki te taki atu hei kōwhiri i tētahi atu kōwhiringa utu.",
    "DeviceFingerprintLoading": "Uta ana",
    "AuthenticatePurchaseInstructions": "E oti ai tāu hokonga mai, me whai ngā tohutohu nā tō pēke i tuku ai. Taihoa koa. E 5-10 hēkena te roanga mā tēnei whārangi e uta ai.",
    "AuthenticatePurchaseHeader": "Whakamotuhēhēhia tāu hokonga mai",
    "FailureHandlerError": "He raru ki tō hokonga. Hoki ki te taki atu hei kōwhiri i tētahi atu kōwhiringa utu.",
    "CheckoutError": "Kua pā tētahi raru. Kāore i oti te taki atu.",
    "RdsConsentCancel": "Whakakore",
    "RdsConsentMicrosoftAccountLabel": "Pūkete Microsoft",
    "RdsConsentConfirm": "Whakaū",
    "RdsConsentWarning": "Mēnā ehara nāu i te pūkete nei, tīpakona a Whakakore.",
    "RdsConsentTitle": "Whakaūkia tō hono PayPal",
    "RdsConsentRequestError": "Kīhai i taea tō kōwhiringa te tukatuka. Kia ngana anō."
  },
  "prs": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "sq": {
    "SuccessHandlerError": "Sfida përfundoi. Kthehu tek përfundimi i blerjes për ta mbyllur blerjen.",
    "RdsConsentAccountDetailsLabel": "Detajet e llogarisë",
    "RdsConsentLead": "Po lidh një llogari PayPal me këtë llogari Microsoft.",
    "CancelHandlerError": "Sfida u anulua. Kthehu në arkë për të zgjedhur një mënyrë tjetër pagese.",
    "DeviceFingerprintLoading": "Po ngarkohet",
    "AuthenticatePurchaseInstructions": "Për të përfunduar blerjen, ndiq udhëzimet që të ka dhënë banka jote. Prit. Kjo faqe mund të marrë 5-10 sekonda për t'u ngarkuar.",
    "AuthenticatePurchaseHeader": "Autentifiko blerjen tënd",
    "FailureHandlerError": "Pati një problem me blerjen tënde. Kthehu në arkë për të zgjedhur një mënyrë tjetër pagese.",
    "CheckoutError": "Diçka nuk shkoi mirë. Blerja nuk u krye.",
    "RdsConsentCancel": "Anulo",
    "RdsConsentMicrosoftAccountLabel": "Llogaria e Microsoft",
    "RdsConsentConfirm": "Konfirmo",
    "RdsConsentWarning": "Nëse kjo s’është llogaria jote, zgjidh \"Anulo\".",
    "RdsConsentTitle": "Konfirmo lidhjen me PayPal",
    "RdsConsentRequestError": "S’mund ta përpunonim zgjedhjen tënde. Provoje përsëri."
  },
  "nso": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "sl": {
    "SuccessHandlerError": "Izziv je zaključen. Vrnite se na stran za dokončanje nakupa, da dokončate nakup.",
    "RdsConsentAccountDetailsLabel": "Podrobnosti računa",
    "RdsConsentLead": "Račun PayPal boste povezali s tem Microsoftovim računom.",
    "CancelHandlerError": "Izziv je preklican. Vrnite se na stran za dokončanje nakupa in izberite drug način plačila.",
    "DeviceFingerprintLoading": "Nalaganje",
    "AuthenticatePurchaseInstructions": "Če želite dokončati nakup, upoštevajte navodila banke. Počakajte. Nalaganje te strani lahko traja od 5 do 10 sekund.",
    "AuthenticatePurchaseHeader": "Potrdite svoj nakup",
    "FailureHandlerError": "Prišlo je do težave z vašim nakupom. Vrnite se na stran za dokončanje nakupa in izberite drug način plačila.",
    "CheckoutError": "Prišlo je do neznane napake. Dokončanje nakupa ni dokončano.",
    "RdsConsentCancel": "Prekliči",
    "RdsConsentMicrosoftAccountLabel": "Microsoftov račun",
    "RdsConsentConfirm": "Potrdi",
    "RdsConsentWarning": "Če to ni vaš račun, izberite »Prekliči«.",
    "RdsConsentTitle": "Potrdite povezavo storitve PayPal",
    "RdsConsentRequestError": "Vaše možnosti ni bilo mogoče obdelati. Poskusite znova."
  },
  "is": {
    "SuccessHandlerError": "Áskorun lokið. Farðu aftur í greiðslu til að ljúka kaupunum.",
    "RdsConsentAccountDetailsLabel": "Upplýsingar um reikning",
    "RdsConsentLead": "Þú ert að tengja PayPal-reikning við þennan Microsoft-reikning.",
    "CancelHandlerError": "Hætt við áskorun. Farðu aftur í greiðslu til að velja annan greiðslumáta.",
    "DeviceFingerprintLoading": "Hleður",
    "AuthenticatePurchaseInstructions": "Til að ljúka kaupunum skaltu fylgja leiðbeiningum bankans þíns. Augnablik. Þessi síða getur tekið 5–10 sekúndur að hlaðast.",
    "AuthenticatePurchaseHeader": "Sannvottaðu kaupin",
    "FailureHandlerError": "Vandamál kom upp við kaupin. Farðu aftur í greiðslu til að velja annan greiðslumáta.",
    "CheckoutError": "Eitthvað fór úrskeiðis. Ekki tókst að ljúka kaupum.",
    "RdsConsentCancel": "Hætta við",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-reikningur",
    "RdsConsentConfirm": "Staðfesta",
    "RdsConsentWarning": "Ef þetta er ekki reikningurinn þinn skaltu velja „Hætta við“.",
    "RdsConsentTitle": "Staðfestu PayPal-tenginguna",
    "RdsConsentRequestError": "Ekki tókst að vinna úr valinu þínu. Reyndu aftur."
  },
  "ka": {
    "SuccessHandlerError": "გამოწვევა დასრულებულია. შეძენის დასასრულებლად დაბრუნდით შეკვეთის გაფორმებაზე.",
    "RdsConsentAccountDetailsLabel": "ანგარიშის დეტალური ინფორმაცია",
    "RdsConsentLead": "თქვენ PayPal-ის ანგარიშს Microsoft-ის ამ ანგარიშთან აკავშირებთ.",
    "CancelHandlerError": "გამოწვევა გაუქმდა. გადახდის სხვა ვარიანტის ასარჩევად დაბრუნდით შეკვეთის გაფორმებაზე.",
    "DeviceFingerprintLoading": "მიმდინარეობს ჩატვირთვა",
    "AuthenticatePurchaseInstructions": "შეძენის დასასრულებლად მიჰყევით თქვენი ბანკის მიერ მოწოდებულ ინსტრუქციებს. დაელოდეთ. შესაძლოა, ამ გვერდის ჩატვირთვას 5-10 წამი დასჭირდეს.",
    "AuthenticatePurchaseHeader": "შეძენის ავთენტიფიკაცია",
    "FailureHandlerError": "შეძენასთან დაკავშირებით პრობლემა წარმოიშვა. გადახდის სხვა ვარიანტის ასარჩევად დაბრუნდით შეკვეთის გაფორმებაზე.",
    "CheckoutError": "უცნობი შეფერხებაა. შეკვეთის გაფორმება ვერ შესრულდა.",
    "RdsConsentCancel": "გაუქმება",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-ის ანგარიში",
    "RdsConsentConfirm": "დადასტურება",
    "RdsConsentWarning": "თუ ეს თქვენი ანგარიში არ არის, აირჩიეთ გაუქმება.",
    "RdsConsentTitle": "დაადასტურეთ PayPal-ის ბმული",
    "RdsConsentRequestError": "თქვენი არჩევანი ვერ დამუშავდა. სცადეთ ხელახლა."
  },
  "ku-arab": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "mr": {
    "SuccessHandlerError": "आव्हान पूर्ण केले. आपली खरेदी समाप्त करण्यासाठी चेकआउटवर परत या.",
    "RdsConsentAccountDetailsLabel": "खाते तपशील",
    "RdsConsentLead": "आपण या Microsoft खात्याशी PayPal खाते लिंक करत आहात.",
    "CancelHandlerError": "आव्हान रद्द केले. दुसरा देय पर्याय निवडण्यासाठी चेकआउटवर परत या.",
    "DeviceFingerprintLoading": "लोड होत आहे",
    "AuthenticatePurchaseInstructions": "आपली खरेदी पूर्ण करण्यासाठी, कृपया आपल्या बँकेकडून दिलेल्या सूचनांचे पालन करा. कृपया प्रतीक्षा करा. हे पृष्ठ लोड होण्यासाठी 5-10 सेकंद लागू शकतात.",
    "AuthenticatePurchaseHeader": "आपली खरेदी प्रमाणित करा",
    "FailureHandlerError": "आपल्या खरेदीमध्ये समस्या आली होती. दुसरा देय पर्याय निवडण्यासाठी चेकआउटवर परत या.",
    "CheckoutError": "काहीतरी चूक झाली. चेकआउट पूर्ण झाले नाही.",
    "RdsConsentCancel": "रद्द करा",
    "RdsConsentMicrosoftAccountLabel": "Microsoft खाते",
    "RdsConsentConfirm": "पुष्टी करा",
    "RdsConsentWarning": "हे आपले खाते नसल्यास, रद्द करा निवडा.",
    "RdsConsentTitle": "आपल्या PayPal लिंकची पुष्टी करा",
    "RdsConsentRequestError": "आम्ही आपल्या निवडीवर प्रक्रिया करू शकलो नाही. पुन्हा प्रयत्न करा."
  },
  "xh": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "sr-cyrl-rs": {
    "SuccessHandlerError": "Изазов је завршен. Вратите се на завршетак куповине да бисте довршили куповину.",
    "RdsConsentAccountDetailsLabel": "Детаљи о налогу",
    "RdsConsentLead": "Повезујете PayPal налог са овим Microsoft налогом.",
    "CancelHandlerError": "Изазов је отказан. Вратите се на завршетак куповине да бисте изабрали другу опцију плаћања.",
    "DeviceFingerprintLoading": "Учитавање је у току",
    "AuthenticatePurchaseInstructions": "Да бисте довршили куповину, пратите упутства која вам је послала банка. Сачекајте. Учитавање ове странице може потрајати 5-10 секунди.",
    "AuthenticatePurchaseHeader": "Потврда куповине",
    "FailureHandlerError": "Дошло је до проблема са вашом куповином. Вратите се на завршетак куповине да бисте изабрали другу опцију плаћања.",
    "CheckoutError": "Дошло је до грешке. Није довршен завршетак куповине.",
    "RdsConsentCancel": "Откажи",
    "RdsConsentMicrosoftAccountLabel": "Microsoft налог",
    "RdsConsentConfirm": "Потврди",
    "RdsConsentWarning": "Ако ово није ваш налог, кликните на дугме „Откажи“.",
    "RdsConsentTitle": "Потврдите PayPal везу",
    "RdsConsentRequestError": "Нисмо могли да обрадимо ваш избор. Покушајте поново."
  },
  "fr-ca": {
    "SuccessHandlerError": "Défi réussi. Revenez au paiement pour finaliser votre achat.",
    "RdsConsentAccountDetailsLabel": "Informations sur le compte",
    "RdsConsentLead": "Vous associez un compte PayPal à ce compte Microsoft.",
    "CancelHandlerError": "Défi annulé. Revenez au paiement pour choisir une autre option de paiement.",
    "DeviceFingerprintLoading": "Chargement",
    "AuthenticatePurchaseInstructions": "Pour finaliser votre achat, veuillez suivre les instructions fournies par votre banque. Veuillez patienter. Le chargement de cette page peut prendre entre 5 et 10 secondes.",
    "AuthenticatePurchaseHeader": "Authentifiez votre achat",
    "FailureHandlerError": "Un problème s’est produit lors de votre achat. Revenez au paiement pour choisir une autre option de paiement.",
    "CheckoutError": "Un problème s’est produit. Le paiement n’a pas abouti.",
    "RdsConsentCancel": "Annuler",
    "RdsConsentMicrosoftAccountLabel": "Compte Microsoft",
    "RdsConsentConfirm": "Confirmer",
    "RdsConsentWarning": "Si ce n’est pas votre compte, sélectionnez Annuler.",
    "RdsConsentTitle": "Confirmez la liaison avec votre compte PayPal",
    "RdsConsentRequestError": "Nous n’avons pas pu traiter votre choix. Réessayez."
  },
  "sr-cyrl-ba": {
    "SuccessHandlerError": "Изазов је завршен. Вратите се на благајну да бисте завршили куповину.",
    "RdsConsentAccountDetailsLabel": "Детаљи о рачуну",
    "RdsConsentLead": "Повезујете PayPal рачун са овим Microsoft рачуном.",
    "CancelHandlerError": "Изазов је отказан. Вратите се на благајну да бисте изабрали другу опцију плаћања.",
    "DeviceFingerprintLoading": "Учитавање",
    "AuthenticatePurchaseInstructions": "Да бисте довршили куповину, пратите упутства која вам је послала банка. Сачекајте. Учитавање ове странице може потрајати 5-10 секунди.",
    "AuthenticatePurchaseHeader": "Потврда куповине",
    "FailureHandlerError": "Дошло је до проблема са вашом куповином. Вратите се на благајну да бисте изабрали другу опцију плаћања.",
    "CheckoutError": "Нешто је кренуло наопако. Одјава није довршена.",
    "RdsConsentCancel": "Откажи",
    "RdsConsentMicrosoftAccountLabel": "Microsoft рачун",
    "RdsConsentConfirm": "Потврда",
    "RdsConsentWarning": "Ако ово није ваш рачун, кликните на дугме „Откажи“.",
    "RdsConsentTitle": "Потврдите PayPal везу",
    "RdsConsentRequestError": "Нисмо могли да обрадимо ваш избор. Покушајте поново."
  },
  "ca-es-valencia": {
    "SuccessHandlerError": "Verificació completada. Torna a la pàgina per finalitzar la compra.",
    "RdsConsentAccountDetailsLabel": "Detalls del compte",
    "RdsConsentLead": "Esteu enllaçant un compte de PayPal a este compte de Microsoft.",
    "CancelHandlerError": "Verificació cancel·lada. Torna a la compra per triar una altra opció de pagament.",
    "DeviceFingerprintLoading": "S'està carregant",
    "AuthenticatePurchaseInstructions": "Per completar la compra, seguiu les instruccions que ha proporcionat el banc. Espereu. Esta pàgina pot trigar entre 5 i 10 segons a carregar-se.",
    "AuthenticatePurchaseHeader": "Autentiqueu la compra",
    "FailureHandlerError": "Hi ha hagut un problema amb la compra. Torna a la compra per triar una altra opció de pagament.",
    "CheckoutError": "S'ha produït un error. No s'ha finalitzat la compra.",
    "RdsConsentCancel": "Cancel·la",
    "RdsConsentMicrosoftAccountLabel": "Compte de Microsoft",
    "RdsConsentConfirm": "Confirma",
    "RdsConsentWarning": "Si este compte no és vostre, seleccioneu Cancel·la.",
    "RdsConsentTitle": "Confirmeu l'enllaç de PayPal",
    "RdsConsentRequestError": "No hem pogut processar la vostra sol·licitud. Torneu-ho a provar."
  },
  "mk": {
    "SuccessHandlerError": "Предизвикот е заврши. Вратете се на наплаќањето за да завршите со купувањето.",
    "RdsConsentAccountDetailsLabel": "Детали за сметката",
    "RdsConsentLead": "Поврзувате сметка на PayPal со оваа сметка на Microsoft.",
    "CancelHandlerError": "Предизвикот е откажан. Вратете се на наплаќањето за да изберете друга опција за плаќање.",
    "DeviceFingerprintLoading": "Се вчитува",
    "AuthenticatePurchaseInstructions": "За да завршите со барањето, следете ги инструкциите обезбедени од банката. Почекајте. Вчитувањето на страницата може да потрае 5-10 секунди.",
    "AuthenticatePurchaseHeader": "Автентицирајте го купувањето",
    "FailureHandlerError": "Имаше проблем со купувањето. Вратете се на наплаќањето за да изберете друга опција за плаќање.",
    "CheckoutError": "Нешто не е во ред. Одјавувањето не е завршено.",
    "RdsConsentCancel": "Откажи",
    "RdsConsentMicrosoftAccountLabel": "Сметка на Microsoft",
    "RdsConsentConfirm": "Потврди",
    "RdsConsentWarning": "Ако ова не е вашата сметка, изберете „Откажи“.",
    "RdsConsentTitle": "Потврдете ја врската до PayPal",
    "RdsConsentRequestError": "Не можевме да го обработиме вашиот избор. Обидете се повторно."
  },
  "hy": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "en-us": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "ig": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "es": {
    "SuccessHandlerError": "Desafío completado. Vuelva a la finalización de la compra para completar su compra.",
    "RdsConsentAccountDetailsLabel": "Detalles de la cuenta",
    "RdsConsentLead": "Estás vinculando una cuenta de PayPal a esta cuenta de Microsoft.",
    "CancelHandlerError": "Desafío cancelado. Vuelve a la finalización de la compra para elegir otra opción de pago.",
    "DeviceFingerprintLoading": "Cargando",
    "AuthenticatePurchaseInstructions": "Para completar la compra, siga las instrucciones que le dé su banco. Espere. Esta página puede tardar entre 5 y 10 segundos en cargarse.",
    "AuthenticatePurchaseHeader": "Autenticar la compra",
    "FailureHandlerError": "Ha habido una incidencia con su compra. Vuelve a la finalización de la compra para elegir otra opción de pago.",
    "CheckoutError": "Se ha producido un error. No se completó la compra.",
    "RdsConsentCancel": "Cancelar",
    "RdsConsentMicrosoftAccountLabel": "Cuenta de Microsoft",
    "RdsConsentConfirm": "Confirmar",
    "RdsConsentWarning": "Si esta no es tu cuenta, selecciona Cancelar.",
    "RdsConsentTitle": "Confirma el vínculo con PayPal",
    "RdsConsentRequestError": "No pudimos procesar tu selección. Inténtelo de nuevo."
  },
  "en-gb": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge cancelled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "tt": {
    "SuccessHandlerError": "Тикшерү чарасы тәмамланган. Сатып алуны тәмамлау өчен заказны төзүгә кире кайтыгыз.",
    "RdsConsentAccountDetailsLabel": "Хисап язмасы турында мәгълүмат",
    "RdsConsentLead": "Сез PayPal хисап язмагызны Майкрософт хисап язмасына бәйлисез.",
    "CancelHandlerError": "Тикшерү чарасыннан баш тартылган. Башка түләү вариантын сайлау өчен заказны төзүгә кире кайтыгыз.",
    "DeviceFingerprintLoading": "Йөкләнә",
    "AuthenticatePurchaseInstructions": "Сатып алуны тәмамлау өчен, сезнең банк тарафыннан бирелгән күрсәтмәләрне үтәгез. Көтеп торыгыз. Бу бит йөкләнгәнче 5-10 секунд үтәргә мөмкин.",
    "AuthenticatePurchaseHeader": "Сатып алуны раслагыз",
    "FailureHandlerError": "Сатып алуыгыз белән проблема килеп чыкты. Башка түләү вариантын сайлау өчен заказны төзүгә кире кайтыгыз.",
    "CheckoutError": "Нәрсәдер ялгыш киткән. Тикшерү тәмамланмады.",
    "RdsConsentCancel": "Баш тарту",
    "RdsConsentMicrosoftAccountLabel": "Майкрософт хисап язмасы",
    "RdsConsentConfirm": "Раслау",
    "RdsConsentWarning": "Бу сезнең хисап язмасы булмаса, “Баш тарту” төймәсенә басыгыз.",
    "RdsConsentTitle": "PayPal сылтамасын раслау",
    "RdsConsentRequestError": "Без сезнең сайлавыгызны эшкәртә алмадык. Омтылышны кабатлагыз."
  },
  "pt-pt": {
    "SuccessHandlerError": "Desafio concluído. Regresse à finalização da compra para terminar a sua compra.",
    "RdsConsentAccountDetailsLabel": "Detalhes da conta",
    "RdsConsentLead": "Está a ligar uma conta PayPal a esta conta Microsoft.",
    "CancelHandlerError": "Desafio cancelado. Regresse à finalização da compra para escolher outra opção de pagamento.",
    "DeviceFingerprintLoading": "A carregar",
    "AuthenticatePurchaseInstructions": "Para concluir a compra, siga as instruções fornecidas pelo seu banco. Aguarde. Esta página pode demorar 5 a 10 segundos a carregar.",
    "AuthenticatePurchaseHeader": "Autenticar a sua compra",
    "FailureHandlerError": "Houve um problema com a sua compra. Regresse à finalização da compra para escolher outra opção de pagamento.",
    "CheckoutError": "Algo correu mal. Finalização da compra não concluída.",
    "RdsConsentCancel": "Cancelar",
    "RdsConsentMicrosoftAccountLabel": "Conta Microsoft",
    "RdsConsentConfirm": "Confirmar",
    "RdsConsentWarning": "Se esta não for a sua conta, selecione Cancelar.",
    "RdsConsentTitle": "Confirmar a sua ligação ao PayPal",
    "RdsConsentRequestError": "Não foi possível processar a sua escolha. Tente novamente."
  },
  "gu": {
    "SuccessHandlerError": "ચેલેન્જ પૂર્ણ થયું. તમારી ખરીદી પૂર્ણ કરવા માટે ચેકઆઉટ પર પાછા જાઓ.",
    "RdsConsentAccountDetailsLabel": "ખાતાની વિગતો",
    "RdsConsentLead": "તમે એક PayPal ખાતાને આ Microsoft ખાતા સાથે લિંક કરી રહ્યાં છો.",
    "CancelHandlerError": "ચેલેન્જ રદ કર્યું. અન્ય ચુકવણી વિકલ્પ પસંદ કરવા માટે ચેકઆઉટ પર પાછા જાઓ.",
    "DeviceFingerprintLoading": "લોડ થઈ રહ્યું છે",
    "AuthenticatePurchaseInstructions": "તમારી ખરીદી પૂર્ણ કરવા માટે, કૃપયા તમારી બેંક દ્વારા પ્રદાન કરવામાં આવેલી સૂચનાઓનું પાલન કરો. કૃપયા પ્રતીક્ષા કરો. આ પેજ લોડ થવામાં 5-10 સેકંડ લાગી શકે છે.",
    "AuthenticatePurchaseHeader": "તમારી ખરીદીને પ્રમાણીકૃત કરો",
    "FailureHandlerError": "તમારી ખરીદીમાં એક સમસ્યા આવી હતી. અન્ય ચુકવણી વિકલ્પ પસંદ કરવા માટે ચેકઆઉટ પર પાછા જાઓ.",
    "CheckoutError": "કંઈક ખોટું થયું. ચેકઆઉટ પૂર્ણ થયું નથી.",
    "RdsConsentCancel": "રદ કરો",
    "RdsConsentMicrosoftAccountLabel": "Microsoft ખાતું",
    "RdsConsentConfirm": "પુષ્ટિ કરો",
    "RdsConsentWarning": "જો આ તમારું ખાતું નથી, તો રદ કરોને પસંદ કરો.",
    "RdsConsentTitle": "તમારી PayPal લિંકની પુષ્ટિ કરો",
    "RdsConsentRequestError": "અમે તમારી પસંદગી પર પ્રક્રિયા કરી શક્યાં નથી. ફરીથી પ્રયાસ કરો."
  },
  "bs": {
    "SuccessHandlerError": "Izazov je završen. Vratite se na odjavu da završite kupovinu.",
    "RdsConsentAccountDetailsLabel": "Detalji o računu",
    "RdsConsentLead": "Povezujete PayPal račun s ovim Microsoft računom.",
    "CancelHandlerError": "Izazov je otkazan. Vratite se na odjavu da odaberete drugu opciju plaćanja.",
    "DeviceFingerprintLoading": "Učitavanje",
    "AuthenticatePurchaseInstructions": "Da biste dovršili kupovinu, slijedite upute koje vam je dala banka. Pričekajte. Učitavanje ove stranice može potrajati 5 – 10 sekundi.",
    "AuthenticatePurchaseHeader": "Potvrdite kupovinu",
    "FailureHandlerError": "Došlo je do problema s kupovinom. Vratite se na odjavu da odaberete drugu opciju plaćanja.",
    "CheckoutError": "Nešto nije u redu. Kupovina nije dovršena.",
    "RdsConsentCancel": "Otkaži",
    "RdsConsentMicrosoftAccountLabel": "Microsoft račun",
    "RdsConsentConfirm": "Potvrdi",
    "RdsConsentWarning": "Ako ovo nije vaš nalog, odaberite „Otkaži“.",
    "RdsConsentTitle": "Potvrdite povezivanje s uslugom PayPal",
    "RdsConsentRequestError": "Nismo mogli obraditi vaš izbor. Pokušajte ponovo."
  },
  "ur": {
    "SuccessHandlerError": "چیلنج مکمل ہو گیا۔ اپنی خریداری مکمل کرنے کے لیے چیک آؤٹ پر واپس جائیں۔",
    "RdsConsentAccountDetailsLabel": "اکاؤنٹ کی تفصیلات",
    "RdsConsentLead": "آپ ایک اکاؤنٹ کو اس Microsoft PayPal ساتھ منسلک کر رہے ہیں۔",
    "CancelHandlerError": "چیلنج منسوخ ہو گیا۔ کسی اور ادائیگی کے اختیار کا انتخاب کرنے کے لیے چیک آؤٹ پر واپس جائیں۔",
    "DeviceFingerprintLoading": "لوڈ کیا جا رہا ہے",
    "AuthenticatePurchaseInstructions": "اپنی خریداری مکمل کرنے کے لیے، براہ کرم ان ہدایات پر عمل کریں جو آپ کے بینک کی جانب سے دی گئی ہیں۔ براہ کرم انتظار کریں۔ یہ صفحہ لوڈ ہونے میں 5-10 سیکنڈ لگ سکتے ہیں۔",
    "AuthenticatePurchaseHeader": "اپنی خریداری کی توثیق کریں",
    "FailureHandlerError": "آپ کی خریداری میں ایک مسئلہ پیش آ گیا۔ کسی اور ادائیگی کے اختیار کا انتخاب کرنے کے لیے چیک آؤٹ پر واپس جائیں۔",
    "CheckoutError": "کچھ غلط ہو گیا۔ چیک آؤٹ مکمل نہیں ہوا۔",
    "RdsConsentCancel": "منسوخ کریں",
    "RdsConsentMicrosoftAccountLabel": "Microsoft اکاؤنٹ",
    "RdsConsentConfirm": "تصدیق کریں",
    "RdsConsentWarning": "اگر یہ آپ کا اکاؤنٹ نہیں ہے تو منسوخ کریں کو منتخب کریں۔",
    "RdsConsentTitle": "اپنے PayPal ربط کی تصدیق کریں",
    "RdsConsentRequestError": "ہم آپ کے انتخاب پر عمل نہیں کر سکے۔ دوبارہ کوشش کریں۔"
  },
  "pl": {
    "SuccessHandlerError": "Ukończono wyzwanie. Wróć do wyewidencjonowania, aby zakończyć zakup.",
    "RdsConsentAccountDetailsLabel": "Szczegóły konta",
    "RdsConsentLead": "Łączysz konto PayPal z tym kontem Microsoft.",
    "CancelHandlerError": "Anulowano wyzwanie. Wróć do wyewidencjonowania, aby wybrać inną opcję płatności.",
    "DeviceFingerprintLoading": "Ładowanie",
    "AuthenticatePurchaseInstructions": "Aby sfinalizować zakup, postępuj zgodnie z instrukcjami podanymi przez bank. Zaczekaj. Ładowanie tej strony może potrwać 5–10 sekund.",
    "AuthenticatePurchaseHeader": "Uwierzytelnij zakup",
    "FailureHandlerError": "Wystąpił problem z zakupem. Wróć do wyewidencjonowania, aby wybrać inną opcję płatności.",
    "CheckoutError": "Wystąpił problem. Wyewidencjonowanie nie zostało ukończone.",
    "RdsConsentCancel": "Anuluj",
    "RdsConsentMicrosoftAccountLabel": "Konto Microsoft",
    "RdsConsentConfirm": "Potwierdź",
    "RdsConsentWarning": "Jeśli to nie jest Twoje konto, wybierz przycisk Anuluj.",
    "RdsConsentTitle": "Potwierdź połączenie z usługą PayPal",
    "RdsConsentRequestError": "Nie możemy przetworzyć Twojego wyboru. Spróbuj ponownie."
  },
  "am": {
    "SuccessHandlerError": "ውድድሩ ተጠናቋል። ግዢዎን ለማጠናቀቅ ወደ ክፍያ ይመለሱ።",
    "RdsConsentAccountDetailsLabel": "የመለያ ዝርዝሮች",
    "RdsConsentLead": "የ PayPal መለያን ከዚህ የ Microsoft መለያ ጋር እያገናኙ ነው።",
    "CancelHandlerError": "ውድድሩ ተሰርዟል። ሌላ የክፍያ አማራጭ ለመምረጥ ወደ ክፍያ ይመለሱ።",
    "DeviceFingerprintLoading": "በመጫን ላይ",
    "AuthenticatePurchaseInstructions": "ግዢዎን ለማጠናቀቅ፣ እባክዎ በባንክዎ የቀረቡትን መመሪያዎች ይከተሉ። እባክዎ ይጠብቁ። ይህ ገጽ ለመጫን ከ5-10 ሰከንዶች ሊወስድ ይችላል።",
    "AuthenticatePurchaseHeader": "ግዢዎን ያረጋግጡ",
    "FailureHandlerError": "በግዢዎ ላይ ችግር ነበር። ሌላ የክፍያ አማራጭ ለመምረጥ ወደ ክፍያ ይመለሱ።",
    "CheckoutError": "የሆነ ስህተት ተከስቷል። ሂሳብ መስመር ላይ መዝጋት አልተጠናቀቀም።",
    "RdsConsentCancel": "ይተውት",
    "RdsConsentMicrosoftAccountLabel": "የ Microsoft መለያ",
    "RdsConsentConfirm": "ያረጋግጡ",
    "RdsConsentWarning": "ይህ የእርስዎ መለያ ካልሆነ፣ ይሰርዙን ይምረጡ።",
    "RdsConsentTitle": "የ PayPal አገናኝዎን ያረጋግጡ",
    "RdsConsentRequestError": "የመረጡትን ማከናወን አልቻልንም። እባክህ እንደገና ሞክር።"
  },
  "sr-latn-rs": {
    "SuccessHandlerError": "Izazov je završen. Vratite se na završetak kupovine da biste dovršili kupovinu.",
    "RdsConsentAccountDetailsLabel": "Detalji o nalogu",
    "RdsConsentLead": "Povezujete nalog PayPal sa ovim Microsoft nalogom.",
    "CancelHandlerError": "Izazov je otkazan. Vratite se na završetak kupovine da biste izabrali drugu opciju plaćanja.",
    "DeviceFingerprintLoading": "Učitava se",
    "AuthenticatePurchaseInstructions": "Da biste dovršili kupovinu, pratite uputstva koja vam je dostavila banka. Sačekajte. Učitavanje ove stranice može potrajati 5 do 10 sekundi.",
    "AuthenticatePurchaseHeader": "Potvrdite svoju kupovinu",
    "FailureHandlerError": "Došlo je do problema sa vašom kupovinom. Vratite se na završetak kupovine da biste izabrali drugu opciju plaćanja.",
    "CheckoutError": "Došlo je do greške. Završetak kupovine nije dovršen.",
    "RdsConsentCancel": "Otkaži",
    "RdsConsentMicrosoftAccountLabel": "Microsoft nalog",
    "RdsConsentConfirm": "Potvrdite",
    "RdsConsentWarning": "Ako ovo nije vaš nalog, kliknite na dugme „Otkaži“.",
    "RdsConsentTitle": "Potvrdite PayPal vezu",
    "RdsConsentRequestError": "Nismo mogli da obradimo vaš izbor. Pokušajte ponovo."
  },
  "lo": {
    "SuccessHandlerError": "ການທ້າພິສູດສໍາເລັດແລ້ວ. ກັບຄືນຫາການຈ່າຍເງິນເພື່ອສຳເລັດການຊື້ຂອງທ່ານ.",
    "RdsConsentAccountDetailsLabel": "ລາຍລະອຽດບັນຊີ",
    "RdsConsentLead": "ທ່ານກຳລັງເຊື່ອມໂຍງບັນຊີ PayPal ກັບບັນຊີ Microsoft ນີ້.",
    "CancelHandlerError": "ຍົກເລີກການທ້າພິສູດແລ້ວ. ກັບຄືນຫາການຈ່າຍເງິນເພື່ອເລືອກຕົວເລືອກການຈ່າຍເງິນອື່ນ.",
    "DeviceFingerprintLoading": "ກຳລັງໂຫຼດ",
    "AuthenticatePurchaseInstructions": "ເພື່ອສຳເລັດການຊື້ຂອງທ່ານ, ກະລຸນາປະຕິບັດຕາມຄໍາແນະນໍາທີ່ທະນາຄານຂອງທ່ານໃຫ້. ກະ​ລຸ​ນາ​ລໍ​ຖ້າ. ຫນ້ານີ້ອາດຈະໃຊ້ເວລາ 5-10 ວິນາທີໃນການໂຫຼດ.",
    "AuthenticatePurchaseHeader": "ຮັບຮອງຄວາມຖືກຕ້ອງຂອງການຊື້ຂອງທ່ານ",
    "FailureHandlerError": "ມີບັນຫາກັບການຊື້ຂອງທ່ານ. ກັບຄືນຫາການຈ່າຍເງິນເພື່ອເລືອກຕົວເລືອກການຈ່າຍເງິນອື່ນ.",
    "CheckoutError": "ມີບາງຢ່າງຜິດພາດເກີດຂຶ້ນ. ຈ່າຍເງິນບໍ່ສຳເລັດ.",
    "RdsConsentCancel": "ຍົກເລີກ",
    "RdsConsentMicrosoftAccountLabel": "ບັນຊີ Microsoft",
    "RdsConsentConfirm": "ຢືນຢັນ",
    "RdsConsentWarning": "ຖ້ານີ້ບໍ່ແມ່ນບັນຊີຂອງທ່ານ, ໃຫ້ເລືອກ ຍົກເລີກ.",
    "RdsConsentTitle": "ຢືນຢັນລິ້ງ PayPal ຂອງທ່ານ",
    "RdsConsentRequestError": "ພວກເຮົາບໍ່ສາມາດປະມວນຜົນທາງເລືອກຂອງທ່ານໄດ້. ລອງອີກຄັ້ງ."
  },
  "te": {
    "SuccessHandlerError": "ఛాలెంజ్ పూర్తయింది. మీ కొనుగోలును పూర్తి చేయడానికి చెక్ అవుట్‌కు తిరిగి వెళ్లండి.",
    "RdsConsentAccountDetailsLabel": "ఖాతా వివరాలు",
    "RdsConsentLead": "మీరు ఈ Microsoft అకౌంట్‌కు PayPal ఖాతాను లింక్ చేస్తున్నారు.",
    "CancelHandlerError": "ఛాలెంజ్ రద్దు చేయబడింది. మరొక చెల్లింపు ఎంపికను ఎంచుకోవడానికి చెక్ అవుట్‌కు తిరిగి వెళ్లండి.",
    "DeviceFingerprintLoading": "లోడ్ అవుతోంది",
    "AuthenticatePurchaseInstructions": "మీ కొనుగోలును పూర్తి చేయడానికి, దయచేసి మీ బ్యాంకు ఇచ్చిన సూచనలను అనుసరించండి. దయచేసి వేచి ఉండండి. ఈ పేజీ లోడ్ కావడానికి 5-10 సెకన్లు పట్టవచ్చు.",
    "AuthenticatePurchaseHeader": "మీ కొనుగోలును ప్రమాణీకరించండి",
    "FailureHandlerError": "మీ కొనుగోలులో సమస్య ఏర్పడింది. మరొక చెల్లింపు ఎంపికను ఎంచుకోవడానికి చెక్ అవుట్‌కు తిరిగి వెళ్లండి.",
    "CheckoutError": "ఏదో తప్పు జరిగింది. చెక్ అవుట్ పూర్తి కాలేదు.",
    "RdsConsentCancel": "రద్దు చేయి",
    "RdsConsentMicrosoftAccountLabel": "Microsoft అకౌంట్",
    "RdsConsentConfirm": "ధృవీకరించు",
    "RdsConsentWarning": "ఇది మీ ఖాతా కాకపోతే, రద్దు చేయిని ఎంచుకోండి.",
    "RdsConsentTitle": "మీ PayPal లింక్‌ని ధృవీకరించండి",
    "RdsConsentRequestError": "మేము మీ ఎంపికను ప్రాసెస్ చేయలేకపోయాము. మళ్లీ ప్రయత్నించండి."
  },
  "cy": {
    "SuccessHandlerError": "Her wedi’i chwblhau. Ewch yn ôl i’r sgrin talu i orffen prynu.",
    "RdsConsentAccountDetailsLabel": "Manylion y cyfrif",
    "RdsConsentLead": "Rydych chi’n cysylltu cyfrif PayPal â’r cyfrif Microsoft hwn.",
    "CancelHandlerError": "Her wedi’i chanslo. Ewch yn ôl i’r sgrin talu i ddewis opsiwn talu arall.",
    "DeviceFingerprintLoading": "Wrthi'n llwytho",
    "AuthenticatePurchaseInstructions": "I gwblhau eich pryniant, dilynwch y cyfarwyddiadau a ddarparwyd gan eich banc. Arhoswch. Gall y dudalen hon gymryd 5-10 eiliad i'w llwytho.",
    "AuthenticatePurchaseHeader": "Dilysu eich pryniant",
    "FailureHandlerError": "Roedd problem gyda’ch pryniant. Ewch yn ôl i’r sgrin talu i ddewis opsiwn talu arall.",
    "CheckoutError": "Aeth rhywbeth o'i le. Heb orffen talu.",
    "RdsConsentCancel": "Canslo",
    "RdsConsentMicrosoftAccountLabel": "Cyfrif Microsoft",
    "RdsConsentConfirm": "Cadarnhau",
    "RdsConsentWarning": "Os nad eich cyfrif chi yw hwn, dewiswch Canslo.",
    "RdsConsentTitle": "Dolen Cadarnhau eich PayPal",
    "RdsConsentRequestError": "Ni allem brosesu eich dewis. Rhowch gynnig arall arni."
  },
  "de": {
    "SuccessHandlerError": "Captcha abgeschlossen. Kehren Sie zur Kasse zurück, um Ihren Kauf abzuschließen.",
    "RdsConsentAccountDetailsLabel": "Kontodetails",
    "RdsConsentLead": "Sie verknüpfen ein PayPal-Konto mit diesem Microsoft-Konto.",
    "CancelHandlerError": "Captcha abgebrochen. Kehren Sie zur Kasse zurück, um eine andere Zahlungsoption auszuwählen.",
    "DeviceFingerprintLoading": "Wird geladen",
    "AuthenticatePurchaseInstructions": "Um Ihren Kauf abzuschließen, befolgen Sie bitte die Anweisungen Ihrer Bank. Bitte warten. Das Laden dieser Seite kann 5 bis 10 Sekunden dauern.",
    "AuthenticatePurchaseHeader": "Authentifizieren Ihres Kaufs",
    "FailureHandlerError": "Beim Kauf ist ein Problem aufgetreten. Kehren Sie zur Kasse zurück, um eine andere Zahlungsoption auszuwählen.",
    "CheckoutError": "Etwas ist schiefgegangen. Das Check-Out konnte nicht abgeschlossen werden.",
    "RdsConsentCancel": "Abbrechen",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-Konto",
    "RdsConsentConfirm": "Bestätigen",
    "RdsConsentWarning": "Wenn dies nicht Ihr Konto ist, wählen Sie „Abbrechen“.",
    "RdsConsentTitle": "PayPal-Verknüpfung bestätigen",
    "RdsConsentRequestError": "Ihre Auswahl konnte nicht verarbeitet werden. Versuchen Sie es erneut."
  },
  "nl": {
    "SuccessHandlerError": "Uitdaging voltooid. Terug naar de betaling om uw aankoop te voltooien.",
    "RdsConsentAccountDetailsLabel": "Accountgegevens",
    "RdsConsentLead": "U koppelt een PayPal-account aan deze Microsoft-account.",
    "CancelHandlerError": "Uitdaging is geannuleerd. Terug naar betaling om een andere betalingsoptie te kiezen.",
    "DeviceFingerprintLoading": "Laden...",
    "AuthenticatePurchaseInstructions": "Volg de instructies van uw bank om uw aankoop te voltooien. Een ogenblik geduld. Het kan 5-10 seconden duren om deze pagina te laden.",
    "AuthenticatePurchaseHeader": "Uw aankoop verifiëren",
    "FailureHandlerError": "Er is een probleem opgetreden met uw aankoop. Terug naar betaling om een andere betalingsoptie te kiezen.",
    "CheckoutError": "Er is iets misgegaan. Uitchecken is niet voltooid.",
    "RdsConsentCancel": "Annuleren",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-account",
    "RdsConsentConfirm": "Bevestigen",
    "RdsConsentWarning": "Als dit niet uw account is, selecteert u Annuleren.",
    "RdsConsentTitle": "Uw PayPal-koppeling bevestigen",
    "RdsConsentRequestError": "Uw keuze kan niet worden verwerkt. Probeer het opnieuw."
  },
  "ja": {
    "SuccessHandlerError": "チャレンジが完了しました。チェックアウトに戻り、購入を完了してください。",
    "RdsConsentAccountDetailsLabel": "アカウントの詳細",
    "RdsConsentLead": "この Microsoft アカウントに PayPal アカウントをリンクしています。",
    "CancelHandlerError": "チャレンジが取り消されました。チェックアウトに戻り、別のお支払い方法を選択してください。",
    "DeviceFingerprintLoading": "読み込み中",
    "AuthenticatePurchaseInstructions": "購入を完了するには、銀行からの指示に従ってください。お待ちください。このページの読み込みには 5 から 10 秒かかることがあります。",
    "AuthenticatePurchaseHeader": "購入の認証",
    "FailureHandlerError": "購入で問題が発生しました。チェックアウトに戻り、別のお支払い方法を選択してください。",
    "CheckoutError": "問題が発生しました。チェックアウトが完了していません。",
    "RdsConsentCancel": "キャンセル",
    "RdsConsentMicrosoftAccountLabel": "Microsoft アカウント",
    "RdsConsentConfirm": "確認",
    "RdsConsentWarning": "このアカウントがご自身のものでない場合は、[キャンセル] を選択してください。",
    "RdsConsentTitle": "PayPal リンクの確認",
    "RdsConsentRequestError": "選択内容を処理できませんでした。もう一度お試しください。"
  },
  "be": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "no": {
    "SuccessHandlerError": "Utfordringen er fullført. Gå tilbake til kassen for å fullføre kjøpet.",
    "RdsConsentAccountDetailsLabel": "Kontodetaljer",
    "RdsConsentLead": "Du kobler en PayPal-konto til denne Microsoft-kontoen.",
    "CancelHandlerError": "Utfordringen er avbrutt. Gå tilbake til kassen for å velge et annet betalingsalternativ.",
    "DeviceFingerprintLoading": "Laster inn",
    "AuthenticatePurchaseInstructions": "Følg instruksjonene fra banken din for å fullføre kjøpet. Vent litt. Det kan ta 5–10 sekunder å laste inn denne siden.",
    "AuthenticatePurchaseHeader": "Godkjenn kjøpet",
    "FailureHandlerError": "Det oppstod et problem med kjøpet. Gå tilbake til kassen for å velge et annet betalingsalternativ.",
    "CheckoutError": "Det oppstod en feil. Betalingen ble ikke fullført.",
    "RdsConsentCancel": "Avbryt",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-konto",
    "RdsConsentConfirm": "Bekreft",
    "RdsConsentWarning": "Velg Avbryt hvis dette ikke er din konto.",
    "RdsConsentTitle": "Bekreft PayPal-koblingen",
    "RdsConsentRequestError": "Vi kunne ikke behandle valget. Prøv på nytt."
  },
  "sw": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "kok": {
    "SuccessHandlerError": "आव्हान पुराय केलां. तुमची खरेदी पूर्ण करूंक, चॅकआवटाचेर परतुचें.",
    "RdsConsentAccountDetailsLabel": "अकाउंट तपशील",
    "RdsConsentLead": "तुमी ह्या Microsoft खात्याचेर एक PayPal अकाउंट लिंक करतात.",
    "CancelHandlerError": "आव्हान रद्द केलां. फारीकणीचो दुसरो पर्याय निवडूंक, चॅकआवटाचेर परतुचें.",
    "DeviceFingerprintLoading": "लोडींग",
    "AuthenticatePurchaseInstructions": "तुमची खरेदी पूर्ण करपाक, उपकार करून तुमच्या बँकेन दिल्ल्यो सुचोवण्यो पाळच्यो. उपकार करून वाट पळोवची. हें पान लोड जावपाक 5-10 सेकंद लागू शकतात.",
    "AuthenticatePurchaseHeader": "तुमची खरेदी प्रमाणीत करात",
    "FailureHandlerError": "तुमचे खरेदी कडेन एक समस्या आशिल्ली. फारीकणीचो दुसरो पर्याय निवडूंक, चॅकआवटाचेर परतुचें.",
    "CheckoutError": "किदें तरी चुकीचें घडलां. चॅकआवट पूर्ण जावंक ना.",
    "RdsConsentCancel": "रद्द करचें",
    "RdsConsentMicrosoftAccountLabel": "Microsoft खातें",
    "RdsConsentConfirm": "खात्री करची",
    "RdsConsentWarning": "जर हो तुमचो अकाउंट न्हय, तर रद्द करचें.",
    "RdsConsentTitle": "तुमचो PayPal लिंक खात्री करात",
    "RdsConsentRequestError": "तुमच्या पसंत प्रमाण आमी प्रक्रिया करूंक शकले नात. परत यत्न करचो."
  },
  "vi": {
    "SuccessHandlerError": "Hoàn tất thử thách. Hãy quay lại thanh toán để hoàn tất giao dịch mua.",
    "RdsConsentAccountDetailsLabel": "Chi tiết tài khoản",
    "RdsConsentLead": "Bạn đang liên kết tài khoản PayPal với tài khoản Microsoft này.",
    "CancelHandlerError": "Đã hủy thử thách. Hãy quay lại thanh toán để chọn phương thức thanh toán khác.",
    "DeviceFingerprintLoading": "Đang tải",
    "AuthenticatePurchaseInstructions": "Để hoàn tất giao dịch mua, hãy làm theo hướng dẫn từ ngân hàng của bạn. Vui lòng đợi. Trang này có thể tải mất từ 5 đến 10 giây.",
    "AuthenticatePurchaseHeader": "Xác thực giao dịch mua",
    "FailureHandlerError": "Đã xảy ra sự cố với giao dịch mua. Hãy quay lại thanh toán để chọn phương thức thanh toán khác.",
    "CheckoutError": "Đã xảy ra lỗi. Quy trình thanh toán chưa hoàn thành.",
    "RdsConsentCancel": "Hủy",
    "RdsConsentMicrosoftAccountLabel": "Tài khoản Microsoft",
    "RdsConsentConfirm": "Xác nhận",
    "RdsConsentWarning": "Nếu đây không phải là tài khoản của bạn, hãy chọn Hủy.",
    "RdsConsentTitle": "Xác nhận liên kết PayPal của bạn",
    "RdsConsentRequestError": "Chúng tôi không thể xử lý lựa chọn của bạn. Hãy thử lại."
  },
  "mn": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "fil": {
    "SuccessHandlerError": "Kumpleto na ang hamon. Bumalik sa checkout para tapusin ang iyong pagbili.",
    "RdsConsentAccountDetailsLabel": "Mga detalye ng account",
    "RdsConsentLead": "Nagli-link ka ng PayPal account sa Account sa Microsoft na ito.",
    "CancelHandlerError": "Kinansela ang hamon. Bumalik sa checkout para pumili ng ibang opsyon sa pagbabayad.",
    "DeviceFingerprintLoading": "Naglo-load",
    "AuthenticatePurchaseInstructions": "Para makumpleto ang iyong pagbili, mangyaring sundin ang mga tagubiling ibinigay ng iyong bangko. Mangyaring maghintay. Maaaring umabot ng 5-10 segundo bago ma-load ang page na ito.",
    "AuthenticatePurchaseHeader": "I-authenticate ang iyong pagbili",
    "FailureHandlerError": "Nagkaroon ng isyu sa iyong pagbili. Bumalik sa checkout para pumili ng ibang opsyon sa pagbabayad.",
    "CheckoutError": "Nagkaroon ng problema. Hindi nakumpleto ang pag-checkout.",
    "RdsConsentCancel": "Kanselahin",
    "RdsConsentMicrosoftAccountLabel": "Account sa Microsoft",
    "RdsConsentConfirm": "Kumpirmahin",
    "RdsConsentWarning": "Kung hindi mo ito account, piliin ang Kanselahin.",
    "RdsConsentTitle": "Kumpirmahin ang iyong link sa PayPal",
    "RdsConsentRequestError": "Hindi namin maproseso ang iyong pinili. Subukang muli."
  },
  "rw": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "tn": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "quc": {
    "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
    "RdsConsentAccountDetailsLabel": "Account details",
    "RdsConsentLead": "You are linking a PayPal account to this Microsoft account.",
    "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
    "DeviceFingerprintLoading": "Loading",
    "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load.",
    "AuthenticatePurchaseHeader": "Authenticate your purchase",
    "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
    "CheckoutError": "Something went wrong. Checkout not completed.",
    "RdsConsentCancel": "Cancel",
    "RdsConsentMicrosoftAccountLabel": "Microsoft account",
    "RdsConsentConfirm": "Confirm",
    "RdsConsentWarning": "If this is not your account, select Cancel.",
    "RdsConsentTitle": "Confirm your PayPal link",
    "RdsConsentRequestError": "We couldn't process your choice. Try again."
  },
  "kk": {
    "SuccessHandlerError": "Сынақ аяқталды. Сатып алуды аяқтау үшін рәсімдеуге оралыңыз.",
    "RdsConsentAccountDetailsLabel": "Тіркелгі мәліметтері",
    "RdsConsentLead": "Сіз PayPal тіркелгісін осы Microsoft тіркелгісіне байланыстырып жатырсыз.",
    "CancelHandlerError": "Сынақтан бас тартылды. Басқа төлем параметрін таңдау үшін рәсімдеуге оралыңыз.",
    "DeviceFingerprintLoading": "Жүктелуде",
    "AuthenticatePurchaseInstructions": "Сатып алуды аяқтау үшін банк берген нұсқауларды орындаңыз. Күте тұрыңыз. Бұл бетті жүктеу 5-10 секундты алуы мүмкін.",
    "AuthenticatePurchaseHeader": "Сатып алуды растау",
    "FailureHandlerError": "Сатып алуға байланысты мәселе пайда болды. Басқа төлем параметрін таңдау үшін рәсімдеуге оралыңыз.",
    "CheckoutError": "Бірдеңе дұрыс болмады. Шығарып алу аяқталмады.",
    "RdsConsentCancel": "Бас тарту",
    "RdsConsentMicrosoftAccountLabel": "Microsoft тіркелгісі",
    "RdsConsentConfirm": "Растау",
    "RdsConsentWarning": "Егер бұл сіздің тіркелгіңіз болмаса, «Бас тарту» түймешігін таңдаңыз.",
    "RdsConsentTitle": "PayPal сілтемеңізді растаңыз",
    "RdsConsentRequestError": "Таңдауыңызды өңдеу мүмкін болмады. Қайталап көріңіз."
  },
  "eu": {
    "SuccessHandlerError": "Osatu da erronka. Itzuli ordainketara erosketa amaitzeko.",
    "RdsConsentAccountDetailsLabel": "Kontuaren xehetasunak",
    "RdsConsentLead": "PayPal kontu bat Microsoft kontu honekin lotzen ari zara.",
    "CancelHandlerError": "Erronka bertan behera utzi da. Itzuli ordainketara beste ordainketa-aukera bat aukeratzeko.",
    "DeviceFingerprintLoading": "Kargatzen",
    "AuthenticatePurchaseInstructions": "Erosketa osatzeko, jarraitu zure bankuak emandako argibideei. Itxaron. Orri honek 5-10 segundo behar ditu kargatzeko.",
    "AuthenticatePurchaseHeader": "Egiaztatu zure erosketa",
    "FailureHandlerError": "Arazo bat egon da zure erosketan. Itzuli ordainketara beste ordainketa-aukera bat aukeratzeko.",
    "CheckoutError": "Arazoren bat izan da. Erosketa ez da osatu.",
    "RdsConsentCancel": "Utzi",
    "RdsConsentMicrosoftAccountLabel": "Microsoft kontua",
    "RdsConsentConfirm": "Berretsi",
    "RdsConsentWarning": "Kontu hau zurea ez bada, hautatu \"Utzi\".",
    "RdsConsentTitle": "Baieztatu PayPal-eko esteka",
    "RdsConsentRequestError": "Ezin izan dugu zure aukera prozesatu. Saiatu berriro."
  },
  "bn-in": {
    "SuccessHandlerError": "চ্যালেঞ্জ সম্পন্ন হয়েছে। আপনার কেনাকাটা শেষ করতে চেকআউটে ফিরে যান।",
    "RdsConsentAccountDetailsLabel": "অ্যাকাউন্টের বিশদ বিবরণ",
    "RdsConsentLead": "আপনি এই Microsoft অ্যাকাউন্টে একটি PayPal অ্যাকাউন্ট লিঙ্ক করছেন।",
    "CancelHandlerError": "চ্যালেঞ্জ বাতিল হয়েছে। অন্য অর্থপ্রদানের বিকল্প চয়ন করতে চেকআউটে ফিরে যান।",
    "DeviceFingerprintLoading": "লোড হচ্ছে",
    "AuthenticatePurchaseInstructions": "আপনার কেনাকাটা সম্পূর্ণ করতে, অনুগ্রহ করে আপনার ব্যাঙ্ক কর্তৃক প্রদত্ত নির্দেশাবলী অনুসরণ করুন। অনুগ্রহ করে অপেক্ষা করুন। এই পৃষ্ঠাটি লোড হতে ৫-১০ সেকেন্ড সময় নিতে পারে।",
    "AuthenticatePurchaseHeader": "আপনার কেনাকাটা প্রমাণীকরণ করুন",
    "FailureHandlerError": "আপনার কেনাকাটায় একটি সমস্যা হয়েছে। অন্য অর্থপ্রদানের বিকল্প চয়ন করতে চেকআউটে ফিরে যান।",
    "CheckoutError": "কিছু একটা ভুল হয়েছে। চেকআউট সম্পূর্ণ হয়নি।",
    "RdsConsentCancel": "বাতিল করুন",
    "RdsConsentMicrosoftAccountLabel": "Microsoft অ্যাকাউন্ট",
    "RdsConsentConfirm": "নিশ্চিত করুন",
    "RdsConsentWarning": "যদি এটি আপনার অ্যাকাউন্ট না হয়, তাহলে বাতিল করুন নির্বাচন করুন।",
    "RdsConsentTitle": "আপনার PayPal লিঙ্ক নিশ্চিত করুন",
    "RdsConsentRequestError": "আমরা আপনার পছন্দ প্রক্রিয়া করতে পারিনি। আবার চেষ্টা করুন।"
  },
  "ml": {
    "SuccessHandlerError": "ചലഞ്ച് പൂർത്തിയായി. നിങ്ങളുടെ വാങ്ങൽ പൂർത്തിയാക്കാൻ ചെക്കൗട്ടിലേക്ക് റിട്ടേൺ ചെയ്യുക.",
    "RdsConsentAccountDetailsLabel": "അക്കൗണ്ട് വിശദാംശങ്ങള്‍",
    "RdsConsentLead": "നിങ്ങൾ ഒരു PayPal അക്കൗണ്ട് ഈ Microsoft അക്കൗണ്ടുമായി ലിങ്ക് ചെയ്യുകയാണ്.",
    "CancelHandlerError": "ചലഞ്ച് റദ്ദാക്കി. മറ്റൊരു പേയ്‌മെന്റ് ഓപ്ഷൻ തിരഞ്ഞെടുക്കാൻ ചെക്കൗട്ടിലേക്ക് റിട്ടേൺ ചെയ്യുക.",
    "DeviceFingerprintLoading": "ലോഡുചെയ്യുന്നു",
    "AuthenticatePurchaseInstructions": "നിങ്ങളുടെ വാങ്ങൽ പൂർത്തിയാക്കാൻ, നിങ്ങളുടെ ബാങ്ക് നൽകിയ നിർദ്ദേശങ്ങൾ പാലിക്കുക. കാത്തിരിക്കുക. ഈ പേജ് ലോഡ് ചെയ്യാൻ 5-10 സെക്കൻഡ് സമയമെടുത്തേക്കാം.",
    "AuthenticatePurchaseHeader": "നിങ്ങളുടെ വാങ്ങൽ ആധികാരികമാക്കുക",
    "FailureHandlerError": "നിങ്ങളുടെ വാങ്ങലിൽ ഒരു പ്രശ്‌നമുണ്ടായിരുന്നു. മറ്റൊരു പേയ്‌മെന്റ് ഓപ്ഷൻ തിരഞ്ഞെടുക്കാൻ ചെക്കൗട്ടിലേക്ക് റിട്ടേൺ ചെയ്യുക.",
    "CheckoutError": "എന്തോ കുഴപ്പം സംഭവിച്ചു. ചെക്കൗട്ട് പൂർത്തിയായിട്ടില്ല.",
    "RdsConsentCancel": "റദ്ദാക്കുക",
    "RdsConsentMicrosoftAccountLabel": "Microsoft അക്കൗണ്ട്",
    "RdsConsentConfirm": "സ്ഥിരീകരിക്കുക",
    "RdsConsentWarning": "ഇത് നിങ്ങളുടെ അക്കൗണ്ട് അല്ലെങ്കിൽ, റദ്ദാക്കുക തിരഞ്ഞെടുക്കുക.",
    "RdsConsentTitle": "നിങ്ങളുടെ PayPal ലിങ്ക് സ്ഥിരീകരിക്കുക",
    "RdsConsentRequestError": "ഞങ്ങൾക്ക് നിങ്ങളുടെ തിരഞ്ഞെടുപ്പ് പ്രോസസ് ചെയ്യാൻ കഴിഞ്ഞില്ല. വീണ്ടും ശ്രമിക്കുക."
  },
  "th": {
    "SuccessHandlerError": "การทดสอบเสร็จสมบูรณ์ กลับไปที่เช็คเอาท์เพื่อดำเนินการซื้อของคุณให้เสร็จสิ้น",
    "RdsConsentAccountDetailsLabel": "รายละเอียดบัญชี",
    "RdsConsentLead": "คุณกำลังลิงก์บัญชี PayPal กับบัญชี Microsoft นี้",
    "CancelHandlerError": "การทดสอบถูกยกเลิก กลับไปที่เช็คเอาท์เพื่อเลือกตัวเลือกการชำระเงินอื่น",
    "DeviceFingerprintLoading": "กำลังโหลด",
    "AuthenticatePurchaseInstructions": "หากต้องการดำเนินการซื้อให้เสร็จสมบูรณ์ โปรดทำตามคำแนะนำจากธนาคารของคุณ โปรดรอสักครู่ หน้านี้อาจใช้เวลาโหลด 5-10 วินาที",
    "AuthenticatePurchaseHeader": "รับรองความถูกต้องการซื้อของคุณ",
    "FailureHandlerError": "มีปัญหาเกี่ยวกับการซื้อของคุณ กลับไปที่เช็คเอาท์เพื่อเลือกตัวเลือกการชำระเงินอื่น",
    "CheckoutError": "มีบางอย่างผิดพลาด การเช็คเอาท์ไม่เสร็จสมบูรณ์",
    "RdsConsentCancel": "ยกเลิก",
    "RdsConsentMicrosoftAccountLabel": "บัญชี Microsoft",
    "RdsConsentConfirm": "ยืนยัน",
    "RdsConsentWarning": "ถ้านี่ไม่ใช่บัญชีของคุณ ให้เลือกยกเลิก",
    "RdsConsentTitle": "ยืนยันลิงก์ PayPal ของคุณ",
    "RdsConsentRequestError": "เราไม่สามารถประมวลผลตัวเลือกของคุณได้ ลองอีกครั้ง"
  },
  "az": {
    "SuccessHandlerError": "Tapşırıq tamamlandı. Satınalmanızı bitirmək üçün ödənişə geri qayıdın.",
    "RdsConsentAccountDetailsLabel": "Hesab təfərrüatları",
    "RdsConsentLead": "PayPal hesabını bu Microsoft hesabı ilə əlaqələndirirsiniz.",
    "CancelHandlerError": "Tapşırıq ləğv edildi. Başqa ödəniş variantı seçmək üçün ödənişə geri qayıdın.",
    "DeviceFingerprintLoading": "Yüklənir",
    "AuthenticatePurchaseInstructions": "Satınalmanızı tamamlamaq üçün bankın verdiyi təlimatlara əməl edin. Gözləyin. Bu səhifənin yüklənməsi 5-10 saniyə çəkə bilər.",
    "AuthenticatePurchaseHeader": "Satınalmanızı təsdiqləyin",
    "FailureHandlerError": "Satınalmanızla bağlı problem yarandı. Başqa ödəniş variantı seçmək üçün ödənişə geri qayıdın.",
    "CheckoutError": "Xəta baş verdi. Sifarişi bitirmə tamamlanmadı.",
    "RdsConsentCancel": "İmtina et",
    "RdsConsentMicrosoftAccountLabel": "Microsoft hesabı",
    "RdsConsentConfirm": "Təsdiqlə",
    "RdsConsentWarning": "Bu sizin hesabınız deyilsə, Ləğv et seçimini edin.",
    "RdsConsentTitle": "PayPal əlaqələndirməsini təsdiqləyin",
    "RdsConsentRequestError": "Seçiminizi emal edə bilmədik. Yenidən cəhd edin."
  },
  "da": {
    "SuccessHandlerError": "Udfordringen er gennemført. Gå tilbage til kassen for at afslutte dit køb.",
    "RdsConsentAccountDetailsLabel": "Kontooplysninger",
    "RdsConsentLead": "Du sammenkæder en PayPal-konto med denne Microsoft-konto.",
    "CancelHandlerError": "Udfordringen blev annulleret. Gå tilbage til kassen for at vælge en anden betalingsmetode.",
    "DeviceFingerprintLoading": "Indlæser",
    "AuthenticatePurchaseInstructions": "For at fuldføre dit køb skal du følge vejledningen fra din bank. Vent et øjeblik. Det kan tage 5-10 sekunder at indlæse denne side.",
    "AuthenticatePurchaseHeader": "Godkend dit køb",
    "FailureHandlerError": "Der opstod et problem med dit køb. Gå tilbage til kassen for at vælge en anden betalingsmetode.",
    "CheckoutError": "Noget gik galt. Betalingen blev ikke afsluttet.",
    "RdsConsentCancel": "Annuller",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-konto",
    "RdsConsentConfirm": "Bekræft",
    "RdsConsentWarning": "Hvis dette ikke er din konto, skal du vælge Annuller.",
    "RdsConsentTitle": "Bekræft dit PayPal-link",
    "RdsConsentRequestError": "Vi kunne ikke behandle dit valg. Prøv igen."
  },
  "ug": {
    "SuccessHandlerError": "رىقابەت تاماملاندى. سېتىۋېلىشىڭىزنى تاماملاش ئۈچۈن ھېساب بوغۇشقا قايتىڭ.",
    "RdsConsentAccountDetailsLabel": "ھېسابات تەپسىلاتلىرى",
    "RdsConsentLead": "سىز بىر PayPal ھېساباتىنى بۇ Microsoft ھېساباتىغا ئۇلاۋاتىسىز.",
    "CancelHandlerError": "رىقابەت بىكار قىلىندى. باشقا پۇل تۆلەش تاللانمىسىنى تاللاش ئۈچۈن ھېساب بوغۇشقا قايتىڭ.",
    "DeviceFingerprintLoading": "يۈكلەۋاتىدۇ",
    "AuthenticatePurchaseInstructions": "پۇل تۆلىشىڭىزنى تاماملاش ئۈچۈن، بانكىڭىز تەمىنلىگەن كۆرسەتمىلەرگە ئەگىشىڭ. سەل كۈتۈپ تۇرۇڭ. بۇ بەتنىڭ يۈكلىنىشىگە 5-10 سېكۇنت ۋاقىت كېتىشى مۇمكىن.",
    "AuthenticatePurchaseHeader": "پۇل تۆلىشىڭىزگە ھوقۇق بېرىڭ",
    "FailureHandlerError": "سېتىۋېلىشىڭىزدا مەسىلە كۆرۈلدى. باشقا پۇل تۆلەش تاللانمىسىنى تاللاش ئۈچۈن ھېساب بوغۇشقا قايتىڭ.",
    "CheckoutError": "خاتالىق كۆرۈلۈپ ھېساب بوغۇلمىدى.",
    "RdsConsentCancel": "بىكار قىلىش",
    "RdsConsentMicrosoftAccountLabel": "Microsoft ھېساباتى",
    "RdsConsentConfirm": "جەزملەشتۈرۈش",
    "RdsConsentWarning": "ئەگەر بۇ سىزنىڭ ھېسابىڭىز بولمىسا، «بېكار قىلىش» نى تاللاڭ.",
    "RdsConsentTitle": "PayPal ئۇلانمىڭىزنى جەزملەشتۈرۈڭ",
    "RdsConsentRequestError": "بىز سىزنىڭ تاللىشىڭىزنى بىر تەرەپ قىلالمىدۇق. قايتا سىناپ بېقىڭ."
  },
  "lb": {
    "SuccessHandlerError": "Opfuerderung ofgeschloss. Gitt zeréck op d’Akafsbestätegung, fir Äre Kaf ofzeschléissen.",
    "RdsConsentAccountDetailsLabel": "Kontendetailer",
    "RdsConsentLead": "Dir verknëppt e PayPal-Kont mat dësem Microsoft-Kont.",
    "CancelHandlerError": "Opfuerderung annuléiert. Gitt zeréck op d’Akafsbestätegung, fir eng aner Bezueloptioun ze wielen.",
    "DeviceFingerprintLoading": "Gëtt gelueden",
    "AuthenticatePurchaseInstructions": "Fir Äre Kaf ofzeschléissen, befollegt wgl. d’Instruktioune vun Ärer Bank. Waart wgl. Et ka 5-10 Sekonnen daueren, bis dës Säit lued.",
    "AuthenticatePurchaseHeader": "Authentifizéiert Äre Kaf",
    "FailureHandlerError": "Et gouf e Problem mat Ärem Kaf. Gitt zeréck op d’Akafsbestätegung, fir eng aner Bezueloptioun ze wielen.",
    "CheckoutError": "Et ass eppes schif gelaf. Akaf net ofgeschloss.",
    "RdsConsentCancel": "Ofbriechen",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-Kont",
    "RdsConsentConfirm": "Bestätegen",
    "RdsConsentWarning": "Wann dëst net Äre Kont ass, wielt Ofbriechen.",
    "RdsConsentTitle": "Bestätegt Äre PayPal-Link",
    "RdsConsentRequestError": "Mir konnten Äre Choix net veraarbechten. Probéiert nach eng Kéier."
  },
  "gl": {
    "SuccessHandlerError": "Reto completo. Volva á finalización da compra para finalizar a compra.",
    "RdsConsentAccountDetailsLabel": "Detalles da conta",
    "RdsConsentLead": "Está ligando unha conta de PayPal a esta conta de Microsoft.",
    "CancelHandlerError": "Desafío cancelado. Volva á finalización da compra para escoller outra opción de pago.",
    "DeviceFingerprintLoading": "Cargando",
    "AuthenticatePurchaseInstructions": "Para completar a túa compra, sigue as instrucións que che deu o teu banco. Agarde. Esta páxina pode tardar entre 5 e 10 segundos en cargar.",
    "AuthenticatePurchaseHeader": "Autentica a túa compra",
    "FailureHandlerError": "Houbo un problema coa súa compra. Volva á finalización da compra para escoller outra opción de pago.",
    "CheckoutError": "Produciuse un erro. Non se completou a compra.",
    "RdsConsentCancel": "Cancelar",
    "RdsConsentMicrosoftAccountLabel": "Conta de Microsoft",
    "RdsConsentConfirm": "Confirmar",
    "RdsConsentWarning": "Se esta non é a súa conta, seleccione Cancelar.",
    "RdsConsentTitle": "Confirmar a ligazón con PayPal",
    "RdsConsentRequestError": "Non puidemos procesar a elección. Ténteo de novo."
  },
  "hi": {
    "SuccessHandlerError": "चुनौती पूरी हो गई है. अपनी खरीदारी पूरी करने के लिए चेकआउट पर वापस जाएँ.",
    "RdsConsentAccountDetailsLabel": "खाते का विवरण",
    "RdsConsentLead": "आप किसी PayPal खाते को इस Microsoft खाता से लिंक कर रहे हैं.",
    "CancelHandlerError": "चुनौती रद्द कर दी गई है. अन्य भुगतान विकल्प चुनने के लिए चेकआउट पर वापस जाएँ.",
    "DeviceFingerprintLoading": "लोड हो रहा है",
    "AuthenticatePurchaseInstructions": "अपनी खरीदारी पूरी करने के लिए, कृपया अपने बैंक द्वारा दिए गए निर्देशों का पालन करें. कृपया प्रतीक्षा करें. इस पेज को लोड होने में 5-10 सेकंड लग सकते हैं.",
    "AuthenticatePurchaseHeader": "अपनी खरीदारी प्रमाणित करें",
    "FailureHandlerError": "आपकी खरीदारी में कोई समस्या थी. अन्य भुगतान विकल्प चुनने के लिए चेकआउट पर वापस जाएँ.",
    "CheckoutError": "कुछ गड़बड़ी हुई. चेकआउट नहीं हुआ.",
    "RdsConsentCancel": "रद्द करें",
    "RdsConsentMicrosoftAccountLabel": "Microsoft खाता",
    "RdsConsentConfirm": "पुष्टि करें",
    "RdsConsentWarning": "अगर यह आपका अकाउंट नहीं है, तो कैंसल चुनें.",
    "RdsConsentTitle": "अपने PayPal लिंक की पुष्टि करें",
    "RdsConsentRequestError": "हम आपकी पसंद को संसाधित नहीं कर सके. फिर से कोशिश करें."
  },
  "ta": {
    "SuccessHandlerError": "சவால் வெற்றிகரமாக முடிந்தது. உங்கள் வாங்குதலை முடிக்க செக்அவுட்டுக்குத் திரும்பவும்.",
    "RdsConsentAccountDetailsLabel": "கணக்கு விவரங்கள்",
    "RdsConsentLead": "இந்த Microsoft கணக்குடன் PayPal கணக்கை இணைக்கிறீர்கள்.",
    "CancelHandlerError": "சவால் ரத்து செய்யப்பட்டது. மற்றொரு கட்டண விருப்பத்தைத் தேர்ந்தெடுக்க செக்அவுட்டுக்குத் திரும்பவும்.",
    "DeviceFingerprintLoading": "ஏற்றுகிறது",
    "AuthenticatePurchaseInstructions": "உங்கள் வாங்குதலை நிறைவுசெய்ய, உங்கள் வங்கி வழங்கியுள்ள வழிமுறைகளைப் பின்பற்றவும். காத்திருக்கவும். இந்தப் பக்கத்தை ஏற்றுவதற்கு 5-10 வினாடிகள் எடுக்கலாம்.",
    "AuthenticatePurchaseHeader": "உங்கள் வாங்குதலை அங்கீகரியுங்கள்",
    "FailureHandlerError": "உங்கள் வாங்குதலில் சிக்கல் ஏற்பட்டது. மற்றொரு கட்டண விருப்பத்தைத் தேர்ந்தெடுக்க செக்அவுட்டுக்குத் திரும்பவும்.",
    "CheckoutError": "ஏதோ தவறாகிவிட்டது. வெளியேறுதல் முடிவடையவில்லை.",
    "RdsConsentCancel": "ரத்துசெய்",
    "RdsConsentMicrosoftAccountLabel": "Microsoft கணக்கு",
    "RdsConsentConfirm": "உறுதிப்படுத்து",
    "RdsConsentWarning": "இது உங்கள் கணக்கு இல்லையென்றால், ரத்துசெய் என்பதைத் தேர்ந்தெடுக்கவும்.",
    "RdsConsentTitle": "உங்கள் PayPal இணைப்பை உறுதிப்படுத்தவும்",
    "RdsConsentRequestError": "உங்கள் விருப்பத்தை எங்களால் செயலாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்."
  },
  "et": {
    "SuccessHandlerError": "Küsimus on lahendatud. Ostu lõpuleviimiseks naaske kassasse.",
    "RdsConsentAccountDetailsLabel": "Konto üksikasjad",
    "RdsConsentLead": "Lingite PayPali konto selle Microsofti kontoga.",
    "CancelHandlerError": "Küsimus on tühistatud. Naaske kassasse, et valida mõni muu makseviis.",
    "DeviceFingerprintLoading": "Laadimine",
    "AuthenticatePurchaseInstructions": "Ostu lõpuleviimiseks järgige oma panga juhiseid. Oodake. Selle lehe laadimiseks võib kuluda 5–10 sekundit.",
    "AuthenticatePurchaseHeader": "Ostu autentimine",
    "FailureHandlerError": "Teie ostuga seoses ilmnes probleem. Naaske kassasse, et valida mõni muu makseviis.",
    "CheckoutError": "Midagi läks valesti. Makset ei viidud lõpule.",
    "RdsConsentCancel": "Loobu",
    "RdsConsentMicrosoftAccountLabel": "Microsofti konto",
    "RdsConsentConfirm": "Kinnita",
    "RdsConsentWarning": "Kui see pole teie konto, valige Loobu.",
    "RdsConsentTitle": "PayPali lingi kinnitamine",
    "RdsConsentRequestError": "Me ei saanud teie valikut töödelda. Proovige uuesti."
  },
  "fa": {
    "SuccessHandlerError": "چالش تکمیل شد. برای اتمام خرید خود به پرداخت بازگردید.",
    "RdsConsentAccountDetailsLabel": "جزئیات حساب",
    "RdsConsentLead": "شما در حال پیوند دادن یک حساب PayPal به این حساب Microsoft هستید.",
    "CancelHandlerError": "چالش لغو شد. برای انتخاب یک گزینه پرداخت دیگر، به پرداخت بازگردید.",
    "DeviceFingerprintLoading": "در حال بارگیری",
    "AuthenticatePurchaseInstructions": "برای تکمیل خرید خود، لطفاً دستورالعمل‌های ارائه‌شده توسط بانکتان را دنبال کنید. لطفاً منتظر بمانید. بارگیری این صفحه ممکن است بین ۵ تا ۱۰ ثانیه طول بکشد.",
    "AuthenticatePurchaseHeader": "احراز هویت خرید شما",
    "FailureHandlerError": "در خرید شما مشکلی پیش آمد. برای انتخاب یک گزینه پرداخت دیگر، به پرداخت بازگردید.",
    "CheckoutError": "مشکلی روی داد. پرداخت تکمیل نشده است.",
    "RdsConsentCancel": "لغو",
    "RdsConsentMicrosoftAccountLabel": "حساب Microsoft",
    "RdsConsentConfirm": "تأیید",
    "RdsConsentWarning": "اگر این حساب متعلق به شما نیست، «لغو» را انتخاب کنید.",
    "RdsConsentTitle": "پیوند PayPal خود را تأیید کنید",
    "RdsConsentRequestError": "نتوانستیم انتخاب شما را پردازش کنیم. دوباره امتحان کنید."
  },
  "fi": {
    "SuccessHandlerError": "Haaste suoritettu. Palaa kassalle viimeistelläksesi ostoksen.",
    "RdsConsentAccountDetailsLabel": "Tilin tiedot",
    "RdsConsentLead": "Olet linkittämässä PayPal-tiliä tähän Microsoft-tiliin.",
    "CancelHandlerError": "Haaste peruutettu. Palaa kassalle ja valitse toinen maksutapa.",
    "DeviceFingerprintLoading": "Ladataan",
    "AuthenticatePurchaseInstructions": "Viimeistele osto noudattamalla pankkisi ohjeita. Odota. Sivun latautuminen voi kestää 5–10 sekuntia.",
    "AuthenticatePurchaseHeader": "Vahvista ostoksesi",
    "FailureHandlerError": "Ostossasi oli ongelma. Palaa kassalle ja valitse toinen maksutapa.",
    "CheckoutError": "Jokin meni vikaan. Uloskuittausta ei suoritettu loppuun.",
    "RdsConsentCancel": "Peruuta",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-tili",
    "RdsConsentConfirm": "Vahvista",
    "RdsConsentWarning": "Jos tili ei ole sinun, valitse Peruuta.",
    "RdsConsentTitle": "Vahvista PayPal-linkitys",
    "RdsConsentRequestError": "Valintaasi ei voitu käsitellä. Yritä uudelleen."
  },
  "ko": {
    "SuccessHandlerError": "챌린지가 완료되었습니다. 구매를 완료하려면 체크 아웃으로 돌아갑니다.",
    "RdsConsentAccountDetailsLabel": "계정 세부 정보",
    "RdsConsentLead": "이 Microsoft 계정에 PayPal 계정을 연결하려고 합니다.",
    "CancelHandlerError": "챌린지가 취소되었습니다. 다른 지급 조건을 선택하려면 체크 아웃으로 돌아갑니다.",
    "DeviceFingerprintLoading": "로드하는 중",
    "AuthenticatePurchaseInstructions": "구매를 완료하려면 은행에서 제공하는 지침을 따라주세요. 기다려 주세요. 이 페이지가 로드되는 데 5~10초 정도 걸릴 수 있습니다.",
    "AuthenticatePurchaseHeader": "구매 인증",
    "FailureHandlerError": "구매에 문제가 있습니다. 다른 지급 조건을 선택하려면 체크 아웃으로 돌아갑니다.",
    "CheckoutError": "문제가 발생했습니다. 체크 아웃이 완료되지 않았습니다.",
    "RdsConsentCancel": "취소",
    "RdsConsentMicrosoftAccountLabel": "Microsoft 계정",
    "RdsConsentConfirm": "확인",
    "RdsConsentWarning": "이 계정이 귀하의 계정이 아니면 취소를 선택하세요.",
    "RdsConsentTitle": "PayPal 연결 확인",
    "RdsConsentRequestError": "파일을 처리할 수 없습니다. 다시 시도하세요."
  },
  "nn-no": {
    "SuccessHandlerError": "Utfordringa er fullført. Gå tilbake til kassa for å fullføre kjøpet.",
    "RdsConsentAccountDetailsLabel": "Kontodetaljar",
    "RdsConsentLead": "Du koplar ein PayPal-konto til denne Microsoft-kontoen.",
    "CancelHandlerError": "Utfordringa er avbroten. Gå tilbake til kassa for å velje ein annan betalingsmåte.",
    "DeviceFingerprintLoading": "Lastar inn",
    "AuthenticatePurchaseInstructions": "Følg instruksjonane frå banken din for å fullføre kjøpet. Vent litt. Det kan ta 5–10 sekund for sida å laste inn.",
    "AuthenticatePurchaseHeader": "Stadfest kjøpet",
    "FailureHandlerError": "Det oppstod eit problem med kjøpet. Gå tilbake til kassa for å velje ein annan betalingsmåte.",
    "CheckoutError": "Noko gjekk gale. Betaling ikkje fullført.",
    "RdsConsentCancel": "Avbryt",
    "RdsConsentMicrosoftAccountLabel": "Microsoft-konto",
    "RdsConsentConfirm": "Stadfest",
    "RdsConsentWarning": "Dersom dette ikkje er din konto, må du velje Avbryt.",
    "RdsConsentTitle": "Stadfest PayPal-koplinga",
    "RdsConsentRequestError": "Vi kan ikkje handsame valet ditt. Prøv på nytt."
  },
  "el": {
    "SuccessHandlerError": "Η πρόκληση ολοκληρώθηκε. Επιστρέψτε στην ολοκλήρωση αγοράς για να ολοκληρώσετε την παραγγελία σας.",
    "RdsConsentAccountDetailsLabel": "Λεπτομέρειες λογαριασμού",
    "RdsConsentLead": "Συνδέετε έναν λογαριασμό PayPal με αυτόν τον Λογαριασμό Microsoft.",
    "CancelHandlerError": "Η πρόκληση ακυρώθηκε. Επιστρέψτε στην ολοκλήρωση αγοράς για να επιλέξετε άλλη μέθοδο πληρωμής.",
    "DeviceFingerprintLoading": "Πραγματοποιείται φόρτωση",
    "AuthenticatePurchaseInstructions": "Για να ολοκληρώσετε την αγορά σας, ακολουθήστε τις οδηγίες που παρέχει η τράπεζά σας. Περιμένετε. Η φόρτωση αυτής της σελίδας μπορεί να διαρκέσει 5-10 δευτερόλεπτα.",
    "AuthenticatePurchaseHeader": "Έλεγχος ταυτότητας της αγοράς σας",
    "FailureHandlerError": "Παρουσιάστηκε πρόβλημα με την αγορά σας. Επιστρέψτε στην ολοκλήρωση αγοράς για να επιλέξετε άλλη μέθοδο πληρωμής.",
    "CheckoutError": "Παρουσιάστηκε κάποιο πρόβλημα. Η ανάληψη ελέγχου δεν ολοκληρώθηκε.",
    "RdsConsentCancel": "Άκυρο",
    "RdsConsentMicrosoftAccountLabel": "Λογαριασμός Microsoft",
    "RdsConsentConfirm": "Επιβεβαίωση",
    "RdsConsentWarning": "Αν αυτός δεν είναι ο λογαριασμός σας, επιλέξτε \"Άκυρο\".",
    "RdsConsentTitle": "Δεν ήταν δυνατή η επεξεργασία της επιλογής σας",
    "RdsConsentRequestError": "Δεν ήταν δυνατή η επεξεργασία της επιλογής σας. Προσπαθήστε ξανά."
  }
};
